import { setDefaultOptions, loadModules } from 'esri-loader'
import store from '@/store/index'
import constants, { COLORS_HEX, URL_DEFAULT_ICON_RECURSO } from './constants'
import * as symbology from './GraphicsSimbology'
import VueInst from '../main'
import JSZip from 'jszip'
// import shp from 'shpjs'

import Vue from 'vue'

import proj4 from 'proj4'

import DateService, { FMT, DayjsUnit } from './DateService'
import api from '../api'
import shpwrite from 'shp-write-update'
import { toKML } from '@placemarkio/tokml'
import * as toGeoJSON from '@tmcw/togeojson'

setDefaultOptions({ css: true })

let Q = require('q')

/**
 * Global variables
 */
let map
let mapView

let overviewMap
let mapViewOverview
let simulacionActivaId

// #region MAP
let ExaggeratedElevationLayerSubClass
let elevationLayer
export const createMap = async () => {
  try {
    const [Map] = await loadModules(['esri/Map'])

    await initExaggeratedElevationLayerSubClass()
    elevationLayer = new ExaggeratedElevationLayerSubClass()
    map = new Map({
      ground: {
        layers: [elevationLayer]
      },
      basemap: 'satellite'
    })

    overviewMap = new Map({
      ground: {
        layers: [elevationLayer]
      },
      basemap: 'gray-vector'
    })

    await registerToken()
    await use2D()
    await createLayers()
    await drawContorno()
    await reorderLayers()

    addContornoToOverview()

    await setSearchWidget()
    await compassWidget()
    await legendWidget()

    redrawIncendios()
    redrawInfraestructuras()
  } catch (err) {
    VueInst.$log.error(err)
  }
}

const addContornoToOverview = () => {
  let layerContorno = Object.assign({}, map.findLayerById('layer-contorno'))

  layerContorno.opacity = 1

  // overviewMap.add(layerContorno)
}

let draw
export const drawPolygonAreaToTrackMedios = async () => {
  try {
    const [Draw] = await loadModules(['esri/views/draw/Draw'])
    const [Point] = await loadModules(['esri/geometry/Point'])
    const [projection] = await loadModules(['esri/geometry/projection'])
    const [Polygon] = await loadModules(['esri/geometry/Polygon'])

    let poligono = null
    let poligonoGraphic

    let layer = map.findLayerById('layer-drawPolygon')

    if (!draw) {
      // Se inicializa si no lo está ya
      draw = new Draw({
        view: mapView
      })
    }
    let action = draw.create('polygon')

    return new Promise((resolve, reject) => {
      // PolygonDrawAction.vertex-add
      // Fires when user clicks, or presses the "F" key.
      // Can also be triggered when the "R" key is pressed to redo.
      action.on('vertex-add', async function (evt) {
        let lastVertex = evt.vertices[evt.vertexIndex]
        let point = new Point({
          x: lastVertex[0],
          y: lastVertex[1]
        })

        if (!poligono) {
          poligono = new Polygon({
            spatialReference: {
              wkid: 3857
            }
          })
          poligono.addRing([point, point])
        } else {
          let ringLength = poligono.rings[0].length
          poligono.insertPoint(0, ringLength - 1, point)
        }
        let poligonoGrafico = await createPolygonGraphic(evt.vertices)
        layer.graphics.removeAll()
        layer.graphics.push(poligonoGrafico)
      })

      // Fires when the pointer moves over the view
      action.on('cursor-update', async function (evt) {
        let poligonoGrafico = await createPolygonGraphic(evt.vertices)
        layer.graphics.removeAll()
        layer.graphics.push(poligonoGrafico)
      })

      // Add a graphic representing the completed polygon
      // when user double-clicks on the view or presses the "C" key
      action.on('draw-complete', async function (evt) {
        let geometry4326 = projection.project(poligono, { wkid: 4326 })
        let coordenadasPoligono = '('

        for (let i = 0; i < geometry4326.rings[0].length; i++) {
          let coordenadas = String(geometry4326.rings[0][i]).split(',')
          if (i === geometry4326.rings[0].length - 1) {
            coordenadasPoligono += coordenadas[0] + ' ' + coordenadas[1] + ')'
          } else {
            coordenadasPoligono += coordenadas[0] + ' ' + coordenadas[1] + ', '
          }
        }

        mapView.goTo(poligono, {
          duration: 3000,
          easing: 'in-expo'
        })
        layer.graphics.removeAll()
        resolve(coordenadasPoligono)
      })
    })
  } catch (err) {
    VueInst.$log.error(err)
    throw err
  }
}
export function cancelDrawingPolygon () {
  let layer = map.findLayerById('layer-drawPolygon')
  if (draw) {
    draw.reset()
    layer.graphics.removeAll()
  }
}

async function createPolygonGraphic (vertices) {
  let deferred = Q.defer()
  try {
    const [Polygon, Graphic] = await loadModules([
      'esri/geometry/Polygon',
      'esri/Graphic'
    ])
    let geometry = new Polygon({
      hasZ: false,
      hasM: true,
      rings: vertices,
      spatialReference: { wkid: 3857 }
    })

    let poligonoGraphic = new Graphic({
      geometry: geometry,
      symbol: {
        type: 'simple-fill', // autocasts as SimpleFillSymbol
        color: 'purple',
        style: 'solid',
        outline: {
          // autocasts as SimpleLineSymbol
          color: 'white',
          width: 1
        }
      }
    })

    deferred.resolve(poligonoGraphic)
  } catch (err) {
    VueInst.$log.error(err)
  }

  return deferred.promise
}
async function initExaggeratedElevationLayerSubClass () {
  try {
    const [ElevationLayer, BaseElevationLayer] = await loadModules([
      'esri/layers/ElevationLayer',
      'esri/layers/BaseElevationLayer'
    ])

    ExaggeratedElevationLayerSubClass = BaseElevationLayer.createSubclass({
      properties: {
        id: 'elevation-layer',
        exaggeration: 1
      },

      // The load() method is called when the layer is added to the map prior to it being rendered in the view.
      load: function () {
        this._elevation = new ElevationLayer({
          id: 'elevation-layer',
          url: 'https://elevation3d.arcgis.com/arcgis/rest/services/WorldElevation3D/Terrain3D/ImageServer'
        })

        // wait for the elevation layer to load before resolving load()
        this.addResolvingPromise(
          this._elevation.load().then(() => {
            // get tileInfo, spatialReference and fullExtent from the elevation service
            // this is required for elevation services with a custom spatialReference
            this.tileInfo = this._elevation.tileInfo
            this.spatialReference = this._elevation.spatialReference
            this.fullExtent = this._elevation.fullExtent
          })
        )

        return this
      },

      // Fetches the tile(s) visible in the view
      fetchTile: function (level, row, col, options) {
        // calls fetchTile() on the elevationlayer for the tiles
        // visible in the view
        return this._elevation.fetchTile(level, row, col, options).then(
          function (data) {
            const exaggeration = this.exaggeration
            // `data` is an object that contains the
            // the width and the height of the tile in pixels,
            // and the values of each pixel
            for (let i = 0; i < data.values.length; i++) {
              // Multiply the given pixel value
              // by the exaggeration value
              data.values[i] = data.values[i] * exaggeration
            }

            return data
          }.bind(this)
        )
      }
    })
  } catch (err) {
    VueInst.$log.error(err)
  }
}

export const use2D = async () => {
  // Crea el viewMap 2d
  try {
    const [MapView] = await loadModules(['esri/views/MapView'])

    let newMapView = new MapView({
      map: map,
      container: 'mapNode',
      constraints: {
        rotationEnabled: false
      },
      popupEnabled: true
    })

    newMapView.ui.remove('zoom')

    newMapView.ui.padding = { top: 70, left: 0, right: 15, bottom: 24 }
    onMapViewChange(newMapView)

    mapViewOverview = new MapView({
      container: 'overviewDiv',
      map: overviewMap,
      constraints: {
        rotationEnabled: false,
        maxScale: 2311162.2171545// 4622324.434309
      }
    })

    mapViewOverview.ui.components = []

    mapViewOverview.when(() => {
      mapView.when(() => {
        setup()
      })
    })

    store.dispatch('map/setMap3D', false)
  } catch (err) {
    VueInst.$log.error(err)
  }
}

async function setup () {
  const [Graphic,
    reactiveUtils, promiseUtils] = await loadModules(['esri/Graphic', 'esri/core/reactiveUtils', 'esri/core/promiseUtils'])

  const extent3Dgraphic = new Graphic({
    geometry: null,
    symbol: {
      type: 'simple-fill',
      color: [0, 0, 0, 0.5],
      outline: null
    }
  })
  mapViewOverview.graphics.add(extent3Dgraphic)

  const extentDebouncer = promiseUtils.debounce(async () => {
    if (mapView.stationary) {
      await mapViewOverview.goTo({
        center: mapView.center,
        scale:
        mapView.scale *
          2 *
          Math.max(
            mapView.width / mapViewOverview.width,
            mapView.height / mapViewOverview.height
          )
      })
    }
  })

  reactiveUtils.watch(
    () => mapView.extent,
    (extent) => {
      // Sync the overview map location
      // whenever the 3d view is stationary
      extent3Dgraphic.geometry = extent
    },
    {
      initial: true
    }
  )

  mapView.watch('stationary', (isStationary) => {
    if (isStationary) {
      extentDebouncer()
    }
  })
}

export const getCaptureMapOverview = async (layer) => {
  return await getCaptureMapFeatures(mapViewOverview.graphics, layer)
}

export const measureOverview = async () => {
  return await measurePerimetros(mapViewOverview.graphics)
}

export const use3D = async () => {
  try {
    const [SceneView] = await loadModules(['esri/views/SceneView'])

    closeMapPopups() // Si no se deseleccionan los graficos antes de cambiar de mapview, da error

    let newMapView = new SceneView({
      map: map,
      container: 'mapNode',
      constraints: {
        rotationEnabled: false
      }
    })

    // newMapView.ui.components = (['attribution'])
    let navigation = newMapView.ui.find('navigation-toggle')
    newMapView.ui.remove('zoom')

    newMapView.ui.move(navigation, 'top-right')
    // newMapView.ui.move(compass, 'top-right')
    newMapView.ui.remove('compass')
    newMapView.ui.remove('legend')

    // newMapView.ui.padding = { top: 378, left: 0, right: 60, bottom: 24 }

    onMapViewChange(newMapView)
    store.dispatch('map/setMap3D', true)
  } catch (err) {
    VueInst.$log.error(err)
  }
}

function onMapViewChange (newMapView) {
  let extent =
    mapView && mapView.extent
      ? mapView.extent
      : store.getters['map/paramsComunidad'].EXTENT

  // Destruir contenedor anterior
  if (mapView) {
    // mapView.container = null
    mapView = null
  }
  mapView = newMapView

  setExtentMap(extent)

  clearMeasurement()

  setSearchWidget()

  compassWidget()
  updateWidgetView()

  updateRendererViento()

  assignMapViewEvents()
}

export const getMapView = () => {
  return mapView
}

export const getMapViewOverviewGraphics = () => {
  return mapViewOverview.graphics
}

export const createMarcoCapturaGraphic = async function (params) {
  const [Graphic, Extent] = await loadModules(['esri/Graphic', 'esri/geometry/Extent', 'esri/views/MapView', 'esri/core/reactiveUtils'])

  const extent = new Extent({
    xmin: params.xmin,
    ymin: params.ymin,
    xmax: params.xmax,
    ymax: params.ymax,
    spatialReference: { wkid: 4326 }
  })

  const graphic = new Graphic({
    geometry: extent,
    symbol: {
      type: 'simple-fill',
      color: [0, 0, 0, 0.5],
      outline: null
    }
  })

  return graphic
}

export const establecerEscala = (nuevaEscala) => {
  mapView.constraints = {
    snapToZoom: false
  }
  mapView.goTo({
    scale: nuevaEscala
  },
  {
    duration: 1000, // Ajusta la duración a 2 segundos (2000 ms)
    easing: 'ease-in-out' // Puedes experimentar con diferentes curvas de aceleración
  }).catch(function (error) {
    console.error('Error ajustando la escala:', error)
  })
}

export const capturarPantalla = (frameBounds) => {
  let deferred = Q.defer()

  const options = {
    width: frameBounds.width * 5,
    height: frameBounds.height * 5,
    area: {
      x: frameBounds.x,
      y: frameBounds.y,
      width: frameBounds.width,
      height: frameBounds.height
    }
  }

  mapView
    .takeScreenshot(options)
    .then((screenshot) => {
      deferred.resolve(screenshot.dataUrl)
    })
    .catch((error) => {
      console.error('Error al capturar la pantalla:', error)
    })

  mapView.constraints = {
    snapToZoom: true
  }

  return deferred.promise
}

export const getMap = () => {
  return map
}
// #endregion

// #region MAPVIEW EVENTS
let graphicHighlight = null
let trackHighlight = []

function assignMapViewEvents () {
  // Evento Emit ChangeExtent (Compartir mapa)
  let pointerDown = false

  mapView.watch('extent', (event) => {
    if (event) {
      store.dispatch('shareMap/changeMapExtent', {
        xmax: event.xmax,
        xmin: event.xmin,
        ymax: event.ymax,
        ymin: event.ymin,
        wkid: event.spatialReference.wkid,
        viewpoint: mapView.viewpoint
      })
    }
  })

  // Scale
  mapView.watch('scale', (event) => {
    VueInst.$eventHub.$emit('escalaMap', event)

    // closeMapPopups()
  })

  // Move mouse -> update coordinates
  mapView.on('pointer-move', (event) => {
    if (!pointerDown) {
      sendCoordinates(mapView.toMap(event))
    }
  })

  mapView.on('click', (event) => {
    // Enviar coordenadas para representarlas en el MapaWeb
    sendCoordinates(mapView.toMap(event))

    // Right click -> Context Menu
    if (event.button !== 0) {
      let position = {
        x: event.x,
        y: event.y
      }
      let attributes = {}
      attributes.X = event.mapPoint.x
      attributes.Y = event.mapPoint.y
      attributes.LATITUDE = event.mapPoint.latitude
      attributes.LONGITUDE = event.mapPoint.longitude
      VueInst.$eventHub.$emit('showContextMenu', {
        attributes: attributes,
        position: position
      })
    }

    // Click -> tooltip layer
    mapView
      .hitTest(event)
      .then((response) => {
        let showCustomTooltip = false
        let showSimpleTooltip = false
        let layerId
        let graphicsFilter = response.results.filter((x) => {
          // console.log(x)
          if (event.button === 0) {
            const layer = x.graphic.layer

            if (layer) {
              layerId = layer.id

              // Capas con tooltip custom
              let layersCustomTooltip = [
                'layer-medios',
                'layer-medios-inactivos',
                'layer-track',
                'layer-incendios'
              ]
              let showCustomTooltip = layersCustomTooltip.includes(layerId)
              if (
                layerId === 'layer-track' &&
                x.graphic.symbol.type === 'simple-line'
              ) {
                // Si es la linea del track, no mostrar
                showCustomTooltip = false
              }

              if (showCustomTooltip) {
                return true
              }

              // Capas con coordenadas
              // ['layer-avion', 'layer-helicoptero', 'layer-pick-up']
              let layersWithPopup = [
                'layer-autobomba',
                'layer-bomberos',
                'layer-BRIF',
                'layer-central-comunicaciones',
                'layer-repetidor-comunicaciones',
                'layer-reten',
                'layer-SOS',
                'layer-torreta-vigilancia',
                'layer-estaciones-meteorologicas',
                'layer-punto-agua-aer',
                'layer-punto-agua-ter',
                'layer-punto-encuentro',
                'layer-montes-utilidad',
                'layer-emergencias',
                'layer-imagen-satelite',
                'layer-infraestructuras-propias',
                'layer-perimetros'
                // 'layer-vector-imagen-satelite'
              ]

              showSimpleTooltip = layersWithPopup.includes(layerId)
            }

            return showSimpleTooltip
          }
        })

        if (graphicsFilter.length > 0) {
          let graphic = graphicsFilter[0].graphic
          if (layerId === 'layer-perimetros' && graphicsFilter.length > 1) {
            // Encuentra el objeto con el AREA más pequeño
            const smallestAreaObject = graphicsFilter.reduce((min, current) => {
              return current.graphic.attributes.AREA < min.graphic.attributes.AREA ? current : min
            })

            // Obtén la posición del objeto con el AREA más pequeño
            const position = graphicsFilter.indexOf(smallestAreaObject)
            graphic = graphicsFilter[position].graphic
          }

          let highlightGraphic = []
          // highlightGraphic.push(graphicsFilter[0].graphic)
          highlightGraphic.push(graphic)

          if (layerId === 'layer-contorno' || layerId === 'layer-track') {
            let layer = map.findLayerById('layer-track')
            for (let i of layer.graphics) {
              if (i.attributes.ID_MEDIO === graphic.attributes.ID_MEDIO) {
                highlightGraphic.push(i)
              }
            }
          }

          mapView.whenLayerView(graphic.layer).then((layerView) => {
            for (let i of highlightGraphic) {
              graphicHighlight = layerView.highlight(i)
              trackHighlight.push(graphicHighlight)
            }
          })

          let position = {
            x: event.x,
            y: event.y + 3
          }

          let attributes = JSON.parse(JSON.stringify(graphic.attributes))

          if (showCustomTooltip) {
            attributes.LATITUDE = graphic.geometry.latitude
            attributes.LONGITUDE = graphic.geometry.longitude
            // VueInst.$eventHub.$emit('showPopup', { capa: graphic.layer.id, attributes: attributes, position: position })
          }

          if (attributes) {
            let popupData = {
              layer: graphic.layer.id,
              attributes: attributes,
              position: position
            }
            VueInst.$eventHub.$emit('showPopup', popupData)
          }
        }
      })
      .catch((err) => {
        VueInst.$log.error(err)
        // VueInst.$eventHub.$emit('showPopup', false)
      })
  })

  mapView.on('pointer-up', (event) => {
    pointerDown = false
  })
  mapView.on('pointer-down', (event) => {
    pointerDown = true
    closeMapPopups()
  })

  // Popup functions
  mapView.popup.on('trigger-action', (event) => {
    // TODO: Esto es para los popups de ArcGIS con los medios, no se usa
    if (event.action.id === 'measure-this') {
      // console.log('hola')
    }
  })
}

function closeMapPopups () {
  // Cierra el popup / context menu y deselecciona el grafico seleccionado
  VueInst.$eventHub.$emit('showPopup', false)
  VueInst.$eventHub.$emit('showContextMenu', false)

  if (graphicHighlight) {
    graphicHighlight.remove()
    graphicHighlight = null
  }

  if (trackHighlight.length > 0) {
    for (let i = 0; i < trackHighlight.length; i++) {
      trackHighlight[i].remove()
    }
  }
}
function sendCoordinates (point) {
  if (point) {
    // Definimos lat y lon con un valor de respaldo (0) para que NUNCA sean undefined
    let lat = point.latitude || 0
    let lon = point.longitude || 0
    let xCoord = point.x || 0
    let yCoord = point.y || 0

    let coordenadas = {
      X: xCoord.toFixed(2),
      Y: yCoord.toFixed(2),
      // Ahora usamos 'lat' y 'lon' (que ya no son undefined) y no fallará el toString
      LATITUDE: lat.toFixed(4).toString().replace('.', ','),
      LONGITUDE: lon.toFixed(4).toString().replace('.', ','),
      LATITUDE_GMS: '',
      LONGITUDE_GMS: '',
      X_ETRS89: xCoord.toFixed(0),
      Y_ETRS89: yCoord.toFixed(0)
    }

    if (VueInst && VueInst.$eventHub) {
      VueInst.$eventHub.$emit('coordenadasMap', coordenadas)
    }
  }
}
// #endregion

// #region LAYERS
export const reorderLayers = async () => {
  let layersAdd = store.getters['map/layersAdd']
  let layersMap = map.layers.items

  for (let i = 0; i < layersAdd.length; i++) {
    let layerInMap = layersMap.find((x) => x.id === layersAdd[i].id)

    if (layerInMap) {
      map.reorder(layerInMap, layersAdd[i].posicion)
    }
  }
}

export const createLayers = async () => {
  let thePromises = []
  let layerStore = store.getters['map/layersAdd']

  for (let i = 0; i < layerStore.length; i++) {
    let layerItem = layerStore[i]

    /* if (layerItem.type === 'WMS') {
      thePromises.push(createWMS(layerItem).then((layer) => {
        map.add(layer)
        store.dispatch('addLayer', {id: layerItem.id, title: layerItem.title, visible: layerItem.visible, posicion: layerItem.posicion, addListLayer: layerItem.addListLayer})
      }))
    } else if (layerItem.type === 'wmtsLayer') {
      thePromises.push(createWMTS(layerItem).then((layer) => {
        map.add(layer)
        store.dispatch('addLayer', {id: layerItem.id, title: layerItem.title, visible: layerItem.visible, posicion: layerItem.posicion, addListLayer: layerItem.addListLayer})
      }))
    } else if (layerItem.type === 'geoJsonPuntos') {
      thePromises.push(createGeoJsonPuntos(layerItem).then((layer) => {
        map.add(layer)
        store.dispatch('addLayer', {id: layerItem.id, title: layerItem.title, visible: layerItem.visible, posicion: layerItem.posicion, addListLayer: layerItem.addListLayer})
      }))
    } else */ if (layerItem.type === 'WMS') {
      thePromises.push(
        createWMS(layerItem).then((layer) => {
          map.add(layer)
          store.dispatch('map/addLayer', {
            id: layerItem.id,
            type: layerItem.type,
            title: layerItem.title,
            visible: layerItem.visible,
            featureInfoFormat: layerItem.featureInfoFormat,
            featureInfoUrl: layerItem.featureInfoUrl,
            popupEnabled: layerItem.popupEnabled,
            sublayers: layerItem.sublayers,
            opacity: layerItem.opacity,
            posicion: layerItem.posicion,
            addListLayer: layerItem.addListLayer,
            url: layerItem.baseUrl
          })
        })
      )
    } else if (layerItem.type === 'geoJson') {
      thePromises.push(
        createGeoJsonLayer(layerItem
        ).then((layer) => {
          map.add(layer)
          store.dispatch('map/addLayer', {
            id: layerItem.id,
            title: layerItem.title,
            visible: layerItem.visible,
            opacity: layerItem.opacity,
            posicion: layerItem.posicion,
            addListLayer: layerItem.addListLayer,
            url: layerItem.url
          })
        })
      )
    } else if (layerItem.type === 'featureLayer') {
      thePromises.push(
        createFeatureLayer(layerItem).then((layer) => {
          map.add(layer)
          store.dispatch('map/addLayer', {
            id: layerItem.id,
            title: layerItem.title,
            visible: layerItem.visible,
            opacity: layerItem.opacity,
            posicion: layerItem.posicion,
            addListLayer: layerItem.addListLayer,
            renderer: layer.renderer,
            fields: layer.fields,
            definitionExpression: layer.definitionExpression,
            labelsVisible: layer.labelsVisible,
            legendEnabled: layerItem.legendEnabled,
            objectIdField: layerItem.objectIdField,
            orderBy: layerItem.orderBy
          })
        })
      )
    } else if (layerItem.type === 'graphicsLayer') {
      thePromises.push(
        createGraphicsLayer(layerItem).then((layer) => {
          map.add(layer)
          store.dispatch('map/addLayer', {
            id: layerItem.id,
            title: layerItem.title,
            visible: layerItem.visible,
            opacity: layerItem.opacity,
            posicion: layerItem.posicion,
            addListLayer: layerItem.addListLayer
          })
        })
      )
    } else if (layerItem.type === 'vectorTileLayer') {
      thePromises.push(
        createVectorTileLayer(layerItem).then((layer) => {
          map.add(layer)
          store.dispatch('map/addLayer', {
            id: layerItem.id,
            title: layerItem.title,
            visible: layerItem.visible,
            opacity: layerItem.opacity,
            posicion: layerItem.posicion,
            addListLayer: layerItem.addListLayer
          })
        })
      )
    } else if (layerItem.type === 'MediaLayer') {
      thePromises.push(
        createMediaLayer(layerItem).then((layer) => {
          map.add(layer)
          store.dispatch('map/addLayer', {
            id: layerItem.id,
            source: layerItem.source,
            title: layerItem.title,
            visible: layerItem.visible,
            opacity: layerItem.opacity,
            posicion: layerItem.posicion,
            addListLayer: layerItem.addListLayer
          })
        })
      )
    } else if (layerItem.type === 'groupLayer') {
      thePromises.push(
        createGroupLayer(layerItem).then((layer) => {
          // We load the layer first for retrieve sublayers info like titles. Otherwise sublayers is undefined
          layer.loadAll().then((layerLoaded) => {
            map.add(layerLoaded)
            let sublayers = layer.allLayers.items.map((item) => ({
              id: layer.id,
              title: item.title,
              sublayerId: item.layerId,
              visible: false
            })).reverse()
            let copyLayerItem = { ...layerItem }
            store.dispatch('map/addLayer', {
              id: copyLayerItem.id,
              type: copyLayerItem.type,
              source: copyLayerItem.source,
              title: copyLayerItem.title,
              visible: copyLayerItem.visible,
              sublayers: sublayers,
              opacity: copyLayerItem.opacity,
              posicion: copyLayerItem.posicion,
              addListLayer: copyLayerItem.addListLayer
            })
          })
        })
      )
    } else if (layerItem.type === 'WFS') {
      thePromises.push(
        createWFS(layerItem).then((layer) => {
          layer.load().then(loaded => {
            map.add(loaded)

            store.dispatch('map/addLayer', {
              id: layerItem.id,
              type: layerItem.type,
              title: layerItem.title,
              visible: layerItem.visible,
              addListLayer: layerItem.addListLayer,
              opacity: layerItem.opacity,
              posicion: layerItem.posicion,
              url: layerItem.baseUrl,
              renderer: layer.renderer,
              definitionExpression: layer.definitionExpression,
              labelsVisible: layer.labelsVisible,
              legendEnabled: layerItem.legendEnabled,
              objectIdField: layerItem.objectIdField,
              orderBy: layerItem.orderBy
            })
          })
        })
      )
    }
    /* else if (layer.type === 'simif') {
      thePromises.push(createWMSSimif(layer).then((layer) => {
        map.add(layer)
        store.dispatch('addLayer', {id: layerItem.id, title: layerItem.title, visible: layerItem.visible})
      }))
    } */
  }

  return Q.all(thePromises)
}
export const setExageration3D = (exageration) => {
  let layerEx = map.ground.layers.getItemAt(0)

  if (layerEx) {
    let layer = new ExaggeratedElevationLayerSubClass({
      exaggeration: exageration,
      url: layerEx.url
    })
    map.ground.layers.remove(layerEx)
    map.ground.layers.add(layer)
    // layer.exaggeration = exageration
  }
}
export const setVisibilityLayer = (id, visibility) => {
  if (map) {
    let layer = map.findLayerById(id)
    if (layer) {
      layer.visible = visibility
    }
  }
}

export const setVisibilitySubLayer = (idLayer, sublayer, visibility) => {
  if (map) {
    let layer = map.findLayerById(idLayer)
    let sublayerIndex = layer.allSublayers.items.findIndex((x) => x.title === sublayer.title)

    layer.allSublayers.items[sublayerIndex].visible = visibility
  }
}

export const setOpacityLayer = (id, opacity) => {
  if (map) {
    let layer = map.findLayerById(id)

    if (layer) {
      layer.opacity = opacity
    }
  }
}

export const setDefinitionExpressionLayer = (id, definitionExpression) => {
  if (map) {
    let layer = map.findLayerById(id)

    if (layer) {
      layer.definitionExpression = definitionExpression
    }
  }
}

export const setLabelsLayer = (id, labelsVisible) => {
  if (map) {
    let layer = map.findLayerById(id)

    if (layer) {
      layer.labelsVisible = labelsVisible
    }
  }
}

async function createGroupLayer (layerItem) {
  let deferred = Q.defer()
  try {
    const [GroupLayer, FeatureLayer, SpatialReference] = await loadModules([
      'esri/layers/GroupLayer',
      'esri/layers/FeatureLayer',
      'esri/geometry/SpatialReference'
    ])
    let groupLayer = new GroupLayer({
      id: layerItem.id,
      title: layerItem.title,
      visible: layerItem.visible,
      opacity: layerItem.opacity,
      portalItem: {
        id: layerItem.idItem
      }
    })
    deferred.resolve(groupLayer)
  } catch (err) {
    VueInst.$log.error(err)
  }
  return deferred.promise
}

async function createFeatureLayer (layerItem) {
  let deferred = Q.defer()
  try {
    const [FeatureLayer, SpatialReference] = await loadModules([
      'esri/layers/FeatureLayer',
      'esri/geometry/SpatialReference'
    ])

    let layer
    if (layerItem.url) {
      layer = new FeatureLayer({
        id: layerItem.id,
        url: layerItem.url,
        title: layerItem.title,
        visible: layerItem.visible,
        opacity: layerItem.opacity,
        spatialReference: SpatialReference.WGS84,
        outFields: ['*'],
        legendEnabled: layerItem.legendEnabled !== undefined ? layerItem.legendEnabled : true, // al ser un boolean se necesita poner el distinto de undefined
        orderBy: layerItem.orderBy
      })
    } else if (layerItem.idItem) {
      layer = new FeatureLayer({
        id: layerItem.id,
        title: layerItem.title,
        visible: layerItem.visible,
        opacity: layerItem.opacity,
        spatialReference: SpatialReference.WebMercator,
        outFields: ['*'],
        portalItem: {
          id: layerItem.idItem
        },
        layerId: layerItem.sublayerId,
        legendEnabled: layerItem.legendEnabled !== undefined ? layerItem.legendEnabled : true, // al ser un boolean se necesita poner el distinto de undefined
        orderBy: layerItem.orderBy
      })
    } else if (layerItem.id === 'layer-infraestructuras-propias') {
      layer = new FeatureLayer({
        id: layerItem.id,
        source: [],
        title: layerItem.title,
        visible: layerItem.visible,
        opacity: layerItem.opacity,
        objectIdField: 'ID',
        geometryType: 'point',
        spatialReference: SpatialReference.WGS84,
        renderer: await renderInfraestructuraLayer(),
        labelingInfo: await featureLayerlabels('NOMBRE'),
        labelsVisible: layerItem.labelsVisible,
        outFields: ['*'],
        fields: layerItem.fields

      })
    } else {
      layer = new FeatureLayer({
        id: layerItem.id,
        source: [],
        title: layerItem.title,
        visible: layerItem.visible,
        opacity: layerItem.opacity,
        objectIdField: 'ID',
        geometryType: 'point',
        spatialReference: SpatialReference.WGS84,
        fields: layerItem.fields,
        renderer: await renderMedioLayer(),
        labelingInfo: await featureLayerlabels('ALIAS'),
        definitionExpression: layerItem.definitionExpression,
        labelsVisible: layerItem.labelsVisible,
        outFields: ['*'],
        legendEnabled: layerItem.legendEnabled !== undefined ? layerItem.legendEnabled : true, // al ser un boolean se necesita poner el distinto de undefined
        orderBy: layerItem.orderBy
      })
    }

    deferred.resolve(layer)
  } catch (err) {
    VueInst.$log.error(err)
  }

  return deferred.promise
}

async function createGraphicsLayer (layerItem) {
  let deferred = Q.defer()

  try {
    const [GraphicsLayer] = await loadModules(['esri/layers/GraphicsLayer'])

    let layer = new GraphicsLayer({
      id: layerItem.id,
      title: layerItem.title,
      visible: layerItem.visible,
      opacity: layerItem.opacity
    })

    deferred.resolve(layer)
  } catch (err) {
    VueInst.$log.error(err)
  }
  return deferred.promise
}

async function createVectorTileLayer (layerItem) {
  let deferred = Q.defer()

  try {
    const [VectorTileLayer] = await loadModules([
      'esri/layers/VectorTileLayer'
    ])

    let layer = new VectorTileLayer({
      id: layerItem.id,
      url: layerItem.url,
      title: layerItem.title,
      visible: layerItem.visible,
      opacity: layerItem.opacity,
      style: layerItem.style
    })

    deferred.resolve(layer)
  } catch (err) {
    VueInst.$log.error(err)
  }
  return deferred.promise
}

async function createMediaLayer (layerItem) {
  let deferred = Q.defer()

  try {
    const [MediaLayer] = await loadModules(['esri/layers/MediaLayer'])

    let layer = new MediaLayer({
      id: layerItem.id,
      source: [layerItem.source],
      title: layerItem.title,
      visible: layerItem.visible
      // blendMode: "color-dodge",
      // blendMode: "vivid-light",
      // blendMode: "screen",
      // blendMode: "reflect",
      // blendMode: 'overlay'
    })

    deferred.resolve(layer)
  } catch (err) {
    VueInst.$log.error(err)
  }
  return deferred.promise
}

// #region WFS medios
async function createWFS (layerItem) {
  try {
    const [WFSLayer] = await loadModules(['esri/layers/WFSLayer'])
    return new WFSLayer({
      id: layerItem.id,
      url: layerItem.url,
      title: layerItem.title,
      visible: layerItem.visible,
      opacity: layerItem.opacity,
      renderer: await renderRecursoLayer(),
      labelingInfo: await featureLayerlabels('ALIAS'),
      definitionExpression: layerItem.definitionExpression,
      labelsVisible: layerItem.labelsVisible,
      outFields: ['*'],
      legendEnabled: layerItem.legendEnabled !== undefined ? layerItem.legendEnabled : true, // al ser un boolean se necesita poner el distinto de undefined
      orderBy: layerItem.orderBy,
      refreshInterval: layerItem.refreshInterval
    })
  } catch (err) {
    VueInst.$log.error(err)
    throw err
  }
}

async function renderRecursoLayer () {
  const [UniqueValueRenderer, PictureMarkerSymbol, Color] = await loadModules([
    'esri/renderers/UniqueValueRenderer',
    'esri/symbols/PictureMarkerSymbol',
    'esri/Color'
  ])

  const renderer = new UniqueValueRenderer({
    valueExpression: "$feature.ICON + '|' + $feature.COLOR",
    defaultSymbol: new PictureMarkerSymbol({
      url: URL_DEFAULT_ICON_RECURSO, // URL por defecto si no hay coincidencia
      width: '40px',
      height: '40px'
    })
  })

  const recursoTipos = [
    'agente_forestal',
    'autobomba',
    'avion',
    'bulldozer',
    'comunicaciones',
    'helicoptero',
    'helitransportada',
    'hermes',
    'reten',
    'tecnico_extincion'
  ]

  const radius = 20
  const segments = 60
  const angleStep = (2 * Math.PI) / segments
  const ring = []

  for (let i = 0; i <= segments; i++) {
    const angle = i * angleStep
    const x = radius * Math.cos(angle)
    const y = radius * Math.sin(angle)
    ring.push([x, y])
  }

  constants.estadosMedio.forEach(recursoSectorEstadoTipo => {
    const color = Color.fromHex(recursoSectorEstadoTipo.COLOR).toRgba()
    color[3] = 255 // La opacidad se necesita de 0 a 255
    recursoTipos.forEach(recursoTipo => {
      renderer.addUniqueValueInfo({
        value: `${recursoTipo}|${recursoSectorEstadoTipo.COLOR}`,
        symbol: recursoLayerSymbol(recursoTipo, color, ring, radius)
      })
    })
  })

  // Color inactivo
  recursoTipos.forEach(recursoTipo => {
    const color = Color.fromHex(COLORS_HEX.GRIS).toRgba()
    color[3] = 255 // La opacidad se necesita de 0 a 255
    renderer.addUniqueValueInfo({
      value: `${recursoTipo}|${COLORS_HEX.GRIS}`,
      symbol: recursoLayerSymbol(recursoTipo, color, ring, radius)
    })
  })

  return renderer
}

function recursoLayerSymbol (icon, color, ring, radius) {
  return {
    type: 'cim',
    data: {
      type: 'CIMSymbolReference',
      symbol: {
        type: 'CIMPointSymbol',
        symbolLayers: [
          {
            type: 'CIMPictureMarker',
            enable: true,
            url: `icons/recursos/${icon}.png`,
            size: 30,
            verticalAlignment: 'middle',
            horizontalAlignment: 'center'
          },
          {
            type: 'CIMVectorMarker',
            enable: true,
            size: 26,
            frame: {
              xmin: -radius,
              ymin: -radius,
              xmax: radius,
              ymax: radius
            },
            markerGraphics: [
              {
                type: 'CIMMarkerGraphic',
                geometry: {
                  rings: [ring]
                },
                symbol: {
                  type: 'CIMPolygonSymbol',
                  symbolLayers: [
                    {
                      type: 'CIMSolidFill',
                      enable: true,
                      color
                    }
                  ]
                }
              }
            ],
            anchorPoint: { x: 0, y: 0 },
            anchorPointUnits: 'Relative',
            respectFrame: true
          }

        ]
      }
    }
  }
}
// #endregion WFS medios

async function createWMS (layerItem) {
  let deferred = Q.defer()

  try {
    const [WMSLayer] = await loadModules(['esri/layers/WMSLayer'])

    let layer = new WMSLayer({
      id: layerItem.id,
      url: layerItem.baseUrl,
      popupEnabled: layerItem.popupEnabled,
      featureInfoFormat: layerItem.featureInfoFormat,
      featureInfoUrl: layerItem.featureInfoUrl,
      sublayers: layerItem.sublayers,
      effect: layerItem.effect,
      fetchFeatureInfoFunction: async (query) => {
        const [Graphic, esriRequest] = await loadModules([
          'esri/Graphic',
          'esri/request'
        ])
        // Explicitly request a GeoJSON response.
        query.info_format = 'application/json'

        // Request the first five features (if any).
        query.feature_count = 5

        // Perform the web request.
        const { data } = await esriRequest(layerItem.featureInfoUrl, { query })

        // Convert each GeoJSON feature into an Esri graphic.
        return data.features.map(
          (feature) =>
            new Graphic({
              attributes: feature.properties,

              // Define a popup template to format field names and values in a table.
              popupTemplate: {
                title: layerItem.title,
                content: [{
                  type: 'fields',
                  fieldInfos: layerItem.sublayerFieldInfos
                }]
              }
            })

        )
      },
      title: layerItem.title,
      visible: layerItem.visible,
      opacity: layerItem.opacity
    })
    deferred.resolve(layer)
  } catch (err) {
    VueInst.$log.error(err)
  }
  return deferred.promise
}

export async function createGeoJsonLayer (layerItem) { //, is3d = false
  const deferred = Q.defer()

  try {
    const [GeoJSONLayer] = await loadModules(['esri/layers/GeoJSONLayer'])

    let aux = layerItem.url[0]
    let url = layerItem.url

    if (layerItem.url.length === 0) {
      aux = {
        type: 'FeatureCollection',
        name: 'polygon',
        crs: { type: 'name', properties: { name: 'urn:ogc:def:crs:OGC:1.3:CRS84' } },
        features: [
          {
            type: 'Feature',
            geometry: {
              type: 'Polygon',
              coordinates: [
                [
                  [100.0, 0.0]
                ]
              ]
            },
            properties: {
              Shape_Leng: 100,
              Shape_Area: null,
              VALUE: null
            }
          }
        ]
      }

      const blob = new Blob([JSON.stringify(aux)], { // layerItem.url | geojson
        type: 'application/json'
      })

      // URL reference to the blob
      url = URL.createObjectURL(blob)
    }

    // create new geojson layer using the blob url
    let layer
    if (layerItem.id === 'layer-trabajo-pistas' || layerItem.id === 'layer-puntos-agua') {
      layer = new GeoJSONLayer({
        url, // Using Object as attribute value for GeoJSON features is not supported.
        id: layerItem.id,
        title: layerItem.title,
        visible: layerItem.visible,
        opacity: layerItem.opacity,
        legendEnabled: layerItem.legendEnabled,
        popupEnabled: layerItem.popupEnabled,
        popupTemplate: layerItem.popupTemplate ?? false,
        outFields: ['*']
      })
    } else {
      layer = new GeoJSONLayer({
        url, // Using Object as attribute value for GeoJSON features is not supported.
        id: layerItem.id,
        title: layerItem.title,
        visible: layerItem.visible,
        opacity: layerItem.opacity,
        legendEnabled: layerItem.legendEnabled,
        popupEnabled: layerItem.popupEnabled,
        outFields: ['*']
      })
    }
    deferred.resolve(layer)
  } catch (err) {
    VueInst.$log.error(err)
  }
  return deferred.promise
}

async function createGraphicsPoligonos (response) {
  let deferred = Q.defer()

  try {
    const [Polygon] = await loadModules(['esri/geometry/Polygon'])

    let features = response.features.map(function (feature, i) {
      return {
        geometry: new Polygon({
          hasZ: false,
          hasM: false,
          rings: feature.geometry.rings,
          spatialReference: {
            wkid: 3857
          }
        }),
        attributes: {
          // Nombre: feature.properties.Nombre
        }
      }
    })
    deferred.resolve(features)
  } catch (err) {
    VueInst.$log.error(err)
  }
  return deferred.promise
}
function getWindRenderer2D (minSpeed, maxSpeed, colors) {
  return {
    type: 'simple',

    symbol: {
      type: 'simple-marker',
      path: 'm15.707 15.707-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 0 1 1.414-1.414L11 15.586V6a1 1 0 0 1 2 0v9.586l1.293-1.293a1 1 0 0 1 1.414 1.414z',
      color: 'white',
      angle: 0,
      size: 10,
      outline: {
        color: [255, 255, 255, 0.5],
        width: 0
      }
    },
    visualVariables: [
      {
        type: 'rotation',
        field: 'direction',
        rotationType: 'geographic'
      },
      {
        type: 'color',
        field: 'speed',
        stops: [
          { value: minSpeed, color: colors?.minSpeed },
          { value: (maxSpeed / 2), color: colors?.medSpeed },
          { value: maxSpeed, color: colors?.maxSpeed }
        ],
        valueExpressionTitle: 'Intensidad viento',
        valueExpression: '3'
      },

      {
        type: 'size',
        field: 'speed',
        minDataValue: 0,
        maxDataValue: 5,
        minSize: 17,
        maxSize: 17,
        legendOptions: {
          showLegend: false
        }

      }
    ]
  }
}

function getWindRenderer3D (minSpeed, maxSpeed, colors) {
  return {
    type: 'simple',
    symbol: {
      type: 'point-3d',
      symbolLayers: [
        {
          type: 'object',
          material: { color: '#a38a8a' },
          resource: { href: '/models/flecha_3D.glb' },
          tilt: 0,
          width: 30,
          depth: 80,
          height: 30
        }
      ]
    },
    visualVariables: [
      {
        type: 'rotation',
        valueExpression: '$feature.direction + 180',
        axis: 'heading'
      },
      {
        type: 'color',
        field: 'speed',
        stops: [
          { value: minSpeed, color: colors?.minSpeed },
          { value: (maxSpeed / 2), color: colors?.medSpeed },
          { value: maxSpeed, color: colors?.maxSpeed }
        ]
      },
      // LONGITUD de la flecha
      {
        type: 'size',
        field: 'speed',
        axis: 'depth',
        stops: [
          { value: minSpeed, size: 50 },
          { value: maxSpeed, size: 200 }
        ]
      },
      // GROSOR vertical
      {
        type: 'size',
        field: 'speed',
        axis: 'height',
        stops: [
          { value: minSpeed, size: 15 },
          { value: maxSpeed, size: 30 }
        ]
      },
      // ANCHURA lateral
      {
        type: 'size',
        field: 'speed',
        axis: 'width',
        stops: [
          { value: minSpeed, size: 15 },
          { value: maxSpeed, size: 30 }
        ]
      }
    ]
  }
}

function getWindLineRenderer3D (minSpeed, maxSpeed, colors) {
  return {
    type: 'simple',
    symbol: {
      type: 'line-3d',
      symbolLayers: [
        {
          type: 'line',
          size: 2,
          material: { color: '#ffaa00' }
        }
      ]
    },
    visualVariables: [
      {
        type: 'color',
        field: 'speed',
        stops: [
          { value: minSpeed, color: colors?.minSpeed },
          { value: (maxSpeed / 2), color: colors?.medSpeed },
          { value: maxSpeed, color: colors?.maxSpeed }
        ]
      }
    ]
  }
}
// #endregion

// #region INCENDIOS
export const redrawIncendios = async () => {
  // console.time('REDRAWINCENDIOS')
  if (map) {
    let layer = map.findLayerById('layer-incendios')

    if (layer) {
      let graphicsEmergencias = await createGraphicsEmergencias()
      layer.graphics.items = graphicsEmergencias
    }
  }

  // console.timeEnd('REDRAWINCENDIOS')
}
async function createGraphicsEmergencias () {
  try {
    const [Point] = await loadModules(['esri/geometry/Point'])

    let svgPath = constants.incendioSVGPath

    let emergencias = store.getters['emergencia/emergenciasFiltradas'] // filtro de emergencias desde la store

    let sources = []
    let color = null

    for (let i = 0; i < emergencias.length; i++) {
      let emergencia = emergencias[i]

      if (emergencia.NIVELES?.length > 0 && !emergencia.NIVELES[0].FECHA_FIN) {
        color = emergencia.NIVELES[0].TIPO_NIVEL.COLOR
      } else {
        color = emergencia.ESTADOS?.[0]?.EMERGENCIA_ESTADO_TIPO.COLOR || 'red' // Color por defecto del icono
      }

      let attributes = {
        ID_EMERGENCIA: emergencia.ID_EMERGENCIA,
        NOMBRE: emergencia.NOMBRE,
        MUNICIPIO: emergencia.MUNICIPIO,
        LOCALIDAD: emergencia.LOCALIDAD,
        OBSERVACIONES: emergencia.OBSERVACIONES,
        ID_TIPO_DETECCION: emergencia.ID_TIPO_DETECCION
      }
      let geometry = new Point({
        x: emergencia.LONGITUD,
        y: emergencia.LATITUD
      })

      // let popupTemplate = {
      //   title: 'Incendio {MUNICIPIO}',
      //   content: [{
      //     type: 'fields',
      //     fieldInfos: [{
      //       fieldName: 'OBSERVACIONES',
      //       label: 'Observaciones'
      //     }]
      //   }]
      // }

      sources.push({
        // Circulo blanco de fondo
        geometry: geometry,
        attributes: attributes,
        symbol: {
          type: 'simple-marker',
          style: 'circle',
          color: 'white',
          size: '32px',
          outline: {
            color: 'white'
          }
        }
      })
      sources.push({
        // Icono
        geometry: geometry,
        attributes: attributes,
        symbol: {
          type: 'simple-marker',
          path: svgPath,
          color: color,
          size: '25px',
          outline: {
            color: color
          }
        }
        // popupTemplate: popupTemplate
      })
      sources.push({
        // Texto
        geometry: geometry,
        attributes: attributes,
        symbol: {
          type: 'text', // autocasts as new TextSymbol()
          color: 'black',
          haloColor: 'white',
          haloSize: '2px',
          text: emergencia.NOMBRE || emergencia.MUNICIPIO,
          xoffset: 0,
          yoffset: -22,
          font: {
            // autocasts as new Font()
            size: 8,
            family: 'Arial Unicode MS',
            weight: 'bold'
          }
        }
      })
    }
    return sources
  } catch (err) {
    VueInst.$log.error(err)
  }
  return []
}
export const paintPositionEmergencia = async (point) => {
  try {
    const [Graphic, Point] = await loadModules([
      'esri/Graphic',
      'esri/geometry/Point'
    ])

    mapView.graphics = []

    if (point) {
      let symbol = {
        type: 'simple-marker',
        style: 'x',
        color: 'white',
        size: '15px',
        outline: {
          color: 'red',
          width: '2px'
        }
      }

      let geometry = new Point({
        x: parseFloat(point.LONGITUD),
        y: parseFloat(point.LATITUD)
      })

      let graphic = new Graphic({
        geometry: geometry,
        symbol: symbol
      })

      mapView.graphics.add(graphic)
    }
  } catch (err) {
    VueInst.$log.error(err)
  }
}
// #endregion

export const redrawInfraestructuras = async () => {
  if (map) {
    let layerlayerInfraestructurasPropias = map.findLayerById('layer-infraestructuras-propias')

    if (layerlayerInfraestructurasPropias) {
      let graphicsInfraestructuras = await createGraphicsInfraestructuras()

      const { features } = await layerlayerInfraestructurasPropias.queryFeatures()
      await layerlayerInfraestructurasPropias.applyEdits({
        addFeatures: graphicsInfraestructuras, // new updated features
        deleteFeatures: features // delete the old features
      })
    }
  }
}

async function createGraphicsInfraestructuras () {
  let deferred = Q.defer()
  const [Graphic, Point] = await loadModules([
    'esri/Graphic',
    'esri/geometry/Point'
  ])
  try {
    let infraestructuras = store.getters['infraestructura/infraestructuras'].filter(infra => infra.X && infra.Y)
    let tiposInfraestructuras = store.getters['infraestructura/tipos']
    let categoriasInfraestructuras = store.getters['infraestructura/categorias']
    let municipiosInfraestructuras = store.getters['infraestructura/municipios']
    let provinciasInfraestructuras = store.getters['infraestructura/provincias']
    let responsablesInfraestructuras = store.getters['infraestructura/responsables']
    let sources = []
    for (let i = 0; i < infraestructuras.length; i++) {
      let infraestructura = infraestructuras[i]
      let tipo = tiposInfraestructuras.find(x => x.ID_INFRAESTRUCTURA_TIPO === infraestructura.ID_INFRAESTRUCTURA_TIPO)
      let municipio = municipiosInfraestructuras.find(x => x.ID_MUNICIPIO === infraestructura.MUNICIPIO.ID_MUNICIPIO)
      let attributes = {
        ID_INFRAESTRUCTURA: infraestructura.ID_INFRAESTRUCTURA,
        TIPO: tipo ? tipo.NOMBRE : null,
        CATEGORIA: categoriasInfraestructuras.find(x => x.ID_INFRAESTRUCTURA_CATEGORIA === tipo.ID_INFRAESTRUCTURA_CATEGORIA)
          ? categoriasInfraestructuras.find(x => x.ID_INFRAESTRUCTURA_CATEGORIA === tipo.ID_INFRAESTRUCTURA_CATEGORIA).NOMBRE
          : null,
        MUNICIPIO: municipio ? municipio.NOMBRE : null,
        PROVINCIA: provinciasInfraestructuras.find(x => x.ID_INE_PROVINCIA === municipio.ID_PROVINCIA)
          ? provinciasInfraestructuras.find(x => x.ID_INE_PROVINCIA === municipio.ID_PROVINCIA).LITERAL
          : null,
        RESPONSABLE: responsablesInfraestructuras.find(x => x.ID_ORGANISMO === infraestructura.ID_ORGANISMO)
          ? responsablesInfraestructuras.find(x => x.ID_ORGANISMO === infraestructura.ID_ORGANISMO).ORGANISMO
          : null,
        NOMBRE: infraestructura.NOMBRE,
        FECHA_ALTA: infraestructura.FECHA_ALTA,
        FECHA_BAJA: infraestructura.FECHA_BAJA,
        BORRADO: infraestructura.BORRADO,
        DESCRIPCION: infraestructura.DESCRIPCION,
        DIRECION: infraestructura.DIRECION,
        CODIGO: infraestructura.CODIGO,
        icon: tipo != null ? constants.iconosTiposInfraestructuras.find(icono => icono.TIPO === tipo.NOMBRE).URL + '.png' : null
      }
      let latLong = convertirETRS89ToLatLon(infraestructura.X, infraestructura.Y)
      let geometry = new Point({
        x: latLong[0],
        y: latLong[1]
      })

      let graphic = new Graphic({
        geometry: geometry,
        attributes: attributes
      })
      sources.push(graphic)
    }
    deferred.resolve(sources)
  } catch (err) {
    VueInst.$log.error(err)
  }
  return deferred.promise
}

async function renderInfraestructuraLayer () {
  const [UniqueValueRenderer, PictureMarkerSymbol] = await loadModules([
    'esri/renderers/UniqueValueRenderer',
    'esri/symbols/PictureMarkerSymbol'
  ])
  let renderer = new UniqueValueRenderer({
    field: 'TIPO',
    defaultSymbol: new PictureMarkerSymbol({
      url: 'icons/interrogacion_0.png', // URL por defecto si no hay coincidencia
      width: '40px',
      height: '40px'
    })
  })
  constants.iconosTiposInfraestructuras.forEach(async icono => {
    let value = icono.URL + '.png'
    renderer.addUniqueValueInfo({
      value: icono.TIPO,
      symbol: await createSymbolInfraestructuras('icons/' + value)
    })
  })

  return renderer
}

async function createSymbolInfraestructuras (icono) {
  const [PictureMarkerSymbol] = await loadModules([
    'esri/symbols/PictureMarkerSymbol'
  ])
  return new PictureMarkerSymbol({
    url: icono, // URL por defecto si no hay coincidencia
    width: '40px',
    height: '40px'
  })
}

// #region MEDIOS
async function renderMedioLayer () {
  const [UniqueValueRenderer, PictureMarkerSymbol] = await loadModules([
    'esri/renderers/UniqueValueRenderer',
    'esri/symbols/PictureMarkerSymbol'
  ])

  let renderer = new UniqueValueRenderer({
    field: 'icon',
    defaultSymbol: new PictureMarkerSymbol({
      url: 'icons/interrogacion_0.png', // URL por defecto si no hay coincidencia
      width: '40px',
      height: '40px'
    })
  })

  constants.iconosTiposMedios.forEach(async icono => {
    for (let i = 0; i < 5; i++) {
      let value = icono.URL + '_' + i + '.png'
      renderer.addUniqueValueInfo({
        value: value,
        symbol: await createSymbolMedio('icons/' + value)
      })
    }
  })

  constants.iconosFilterISSI.forEach(async icono => {
    for (let i = 0; i < 5; i++) {
      let value = icono.URL + '_' + i + '.png'
      renderer.addUniqueValueInfo({
        value: value,
        symbol: await createSymbolMedio('icons/' + value)
      })
    }
  })

  for (let i = 0; i < 5; i++) {
    let value = 'interrogacion_' + i + '.png'
    renderer.addUniqueValueInfo({
      value: value,
      symbol: await createSymbolMedio('icons/' + value)
    })
  }

  return renderer
}

async function createSymbolMedio (icono) {
  const [PictureMarkerSymbol] = await loadModules([
    'esri/symbols/PictureMarkerSymbol'
  ])

  return new PictureMarkerSymbol({
    url: icono, // URL por defecto si no hay coincidencia
    width: '40px',
    height: '40px'
  })
}

async function featureLayerlabels (labelAtribute) {
  const [LabelClass] = await loadModules([
    'esri/layers/support/LabelClass'
  ])

  const statesLabelClass = new LabelClass({
    labelExpressionInfo: { expression: '$feature.' + labelAtribute },
    labelPlacement: 'below-center',
    symbol: {
      type: 'text', // autocasts as new TextSymbol()
      color: 'black',
      haloColor: 'white',
      haloSize: '2px',
      font: {
        // autocasts as new Font()
        size: 8,
        family: 'Arial Unicode MS',
        weight: 'bold'
      }
    }
  })
  return [statesLabelClass]
}
// #endregion

// #region TRACKS
let drawLines = false
export function drawLineas (draw) {
  drawLines = draw
}

export const drawTrack = async (
  idMedio,
  medio,
  positions,
  activateGOTO
) => {
  if (map) {
    let layer = map.findLayerById('layer-track')
    let newPositions = await calcularVelocidad(positions)

    let graphics = await createGraphicsTrack(idMedio, medio, newPositions)
    layer.addMany(graphics)
    if (activateGOTO) {
      mapView.goTo(graphics, {
        duration: 3000,
        easing: 'in-expo'
      })
    }

    layer.visible = true
  }
}

export const hideTrack = (idMedio) => {
  if (map) {
    let layer = map.findLayerById('layer-track')
    layer.removeMany(
      layer.graphics.items.filter((x) => x.attributes.ID_MEDIO === idMedio)
    )
    layer.visible = true
  }
}

export const exportTrack = (data) => {
  if (map) {
    let layer = map.findLayerById('layer-track')

    let points = layer.graphics.items.filter(
      (x) => x.attributes.ID_MEDIO === data.idMedio
    )
    points.sort((a, b) => (a.attributes.FECHA > b.attributes.FECHA ? 1 : -1))

    let fechas = points.map((x) => x.attributes.FECHA).filter((x) => x)
    let fechaInicio = fechas[0]

    // Construir GEOJSON
    let features = [
      {
        type: 'Feature',
        geometry: {
          type: 'LineString',
          coordinates: points
            .map((x) => x.geometry)
            .map((x) => [x.longitude, x.latitude])
        },
        properties: {
          MEDIO: data.medio
        }
      }
    ]

    for (let i = 0; i < points.length; i++) {
      if (!points[i].attributes.VELOCIDAD) {
        points[i].attributes.VELOCIDAD = 0
      }
      features.push({
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [
            points[i].geometry.longitude,
            points[i].geometry.latitude
          ]
        },
        properties: points[i].attributes
      })
    }

    let geoJson = {
      type: 'FeatureCollection',
      features: features
    }

    let nombre = data.medio + '_' + fechaInicio

    // Fichero SHP
    try {
      const shpwrite = require('shp-write-update')
      let options = {
        folder: 'Track_' + data.medio,
        types: {
          point: 'PUNTOS_' + nombre,
          polygon: 'POLIGONOS' + nombre,
          line: 'LINEAS' + nombre,
          polyline: 'POLYLINE_' + nombre
        }
      }
      shpwrite.download(geoJson, options)
    } catch (err) {
      console.error('Error generando shp', err)
    }

    // Fichero KML
    try {
      let kml = toKML(geoJson)
      let element = document.createElement('a')
      element.setAttribute(
        'href',
        'data:text/plain;charset=utf-8,' + encodeURIComponent(kml)
      )
      element.setAttribute('download', 'Track_' + nombre + '.kml')
      element.style.display = 'none'
      document.body.appendChild(element)
      element.click()
      document.body.removeChild(element)
    } catch (err) {
      console.error('Error generando kml', err)
    }
  }
}

export const exportPerimetros = (perimetros, tipo = 'KML', nombreBase = 'perimetros') => {
  try {
    const features = perimetros
      .filter(p => p.GRAFICOS_PERIMETRO?.[0]?.geometry)
      .map(p => {
        const g = p.GRAFICOS_PERIMETRO[0].geometry

        const geometry = {
          type: 'Polygon',
          coordinates: g.rings
        }

        return {
          type: 'Feature',
          geometry,
          properties: {
            NOMBRE: p.NOMBRE,
            FECHA: p.FECHA
          }
        }
      })

    const geoJson = {
      type: 'FeatureCollection',
      features
    }

    const timestamp = new Date().toISOString().split('T')[0]
    const folderName = `Perimetros_${timestamp}`

    if (tipo === 'SHP') {
      shpwrite.download(geoJson, {
        folder: folderName,
        types: {
          polygon: `Poligonos_${nombreBase}`
        }
      })
    } else if (tipo === 'KML') {
      const geoJsonTransformado = transformarGeoJsonAEPSG4326(geoJson)
      const kml = toKML(geoJsonTransformado)
      const blob = new Blob([kml], { type: 'application/vnd.google-earth.kml+xml' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `${folderName}.kml`
      link.click()
      URL.revokeObjectURL(url)
    }
  } catch (err) {
    console.error('Error exportando perimetros:', err)
    throw err
  }
}

async function createGraphicsTrack (idMedio, medio, posiciones) {
  let deferred = Q.defer()

  try {
    const [Point, ObjectSymbol3DLayer, PointSymbol3D] = await loadModules([
      'esri/geometry/Point',
      'esri/symbols/ObjectSymbol3DLayer',
      'esri/symbols/PointSymbol3D'
    ])
    let rgbRandomArrow = [
      Math.floor(Math.random() * 255),
      Math.floor(Math.random() * 255),
      Math.floor(Math.random() * 255)
    ]
    let is3D = store.getters['map/isMap3D']
    let rgbRandom = [
      Math.floor(Math.random() * 255),
      Math.floor(Math.random() * 255),
      Math.floor(Math.random() * 255)
    ]
    posiciones.reverse() // Poner en orden creciente

    let sources = []
    let pathPosiciones = []
    for (let i = 0; i < posiciones.length; i++) {
      let rumbo = 0

      if (i < posiciones.length - 1) {
        // Calcula el rumbo para todas las posiciones menos para la ultima
        rumbo = calcularRumbo(
          posiciones[i].LATITUD,
          posiciones[i].LONGITUD,
          posiciones[i + 1].LATITUD,
          posiciones[i + 1].LONGITUD
        )
      }
      rumbo = (rumbo + 180) % 360 // La flecha original apunta hacia abajo

      pathPosiciones.push([posiciones[i].LONGITUD, posiciones[i].LATITUD])

      if (is3D) {
        sources.push({
          // Cada punto
          geometry: new Point({
            x: posiciones[i].LONGITUD,
            y: posiciones[i].LATITUD
          }),
          attributes: {
            ID_MEDIO: idMedio,
            MEDIO: medio,
            FECHA: posiciones[i].FECHA,
            VELOCIDAD: posiciones[i].VELOCIDAD
          },
          symbol: new PointSymbol3D({
            symbolLayers: [
              new ObjectSymbol3DLayer({
                anchor: 'relative',
                anchorPosition: { x: 0, y: 0, z: -0.5 },

                width: 200,
                height: 200,
                tilt: 85,
                heading: rumbo,
                resource: {
                  primitive: 'tetrahedron'
                },
                material: {
                  color: '#FFD700'
                }
              })
            ]
          })
        })
      } else {
        sources.push({
          // Cada punto
          geometry: new Point({
            x: posiciones[i].LONGITUD,
            y: posiciones[i].LATITUD
          }),
          attributes: {
            ID_MEDIO: idMedio,
            MEDIO: medio,
            FECHA: posiciones[i].FECHA,
            VELOCIDAD: posiciones[i].VELOCIDAD
          },
          symbol: {
            type: 'simple-marker',
            path: 'M14.5,29 23.5,0 14.5,9 5.5,0z',
            angle: rumbo,
            color: rgbRandomArrow,
            size: '10px',
            outline: {
              color: rgbRandomArrow
            }
          }
        })

        // Etiqueta del medio sobre el punto
        // se añade cada 3 puntos, para no sobrecargar
        if (i % 3 === 0) {
          sources.push({
            // Cada punto
            geometry: new Point({
              x: posiciones[i].LONGITUD,
              y: posiciones[i].LATITUD
            }),
            attributes: {
              ID_MEDIO: idMedio,
              MEDIO: medio,
              FECHA: posiciones[i].FECHA,
              VELOCIDAD: posiciones[i].VELOCIDAD,
              IS_TAG: true
            },
            symbol: {
              type: 'text', // autocasts as new TextSymbol()
              color: rgbRandomArrow,
              haloColor: 'black',
              haloSize: '0.75px',
              text: medio,
              yoffset: 6,
              font: {
                // autocasts as new Font()
                size: 10,
                family: 'Arial Unicode MS'
              }
            }
          })
        }
      }
    }
    sources.unshift({
      // Linea
      geometry: {
        type: 'polyline',
        paths: pathPosiciones
      },
      attributes: {
        ID_MEDIO: idMedio
      },
      symbol: {
        type: 'simple-line',
        style: 'short-dot',
        color: rgbRandom,
        width: 1
      }
    })

    deferred.resolve(sources)
  } catch (err) {
    VueInst.$log.error(err)
  }

  return deferred.promise
}

async function calcularVelocidad (puntos) {
  // TODO: hacer en backend
  let deferred = Q.defer()

  try {
    const [Point, geometryEngine, SpatialReference, webMercatorUtils] =
      await loadModules([
        'esri/geometry/Point',
        'esri/geometry/geometryEngine',
        'esri/geometry/SpatialReference',
        'esri/geometry/support/webMercatorUtils'
      ])

    let sr = new SpatialReference({ wkid: 102100 })
    for (let i = 0; i < puntos.length; i++) {
      if (i === 0) {
        puntos[i].VELOCIDAD = 0
      } else if (i < puntos.length - 1) {
        let posPoint = webMercatorUtils.lngLatToXY(
          puntos[i].LONGITUD,
          puntos[i].LATITUD
        )
        let posFollowPoint = webMercatorUtils.lngLatToXY(
          puntos[i + 1].LONGITUD,
          puntos[i + 1].LATITUD
        )

        let point = new Point({
          x: posPoint[0],
          y: posPoint[1],
          spatialReference: sr
        })

        let followPoint = new Point({
          x: posFollowPoint[0],
          y: posFollowPoint[1],
          spatialReference: sr
        })

        let distancia = geometryEngine.distance(
          point,
          followPoint,
          'kilometers'
        )

        let fechaPoint = DateService.parseDate(puntos[i].FECHA)
        let fechaFollowPoint = DateService.parseDate(puntos[i + 1].FECHA)

        let tiempo = fechaPoint.diff(fechaFollowPoint, DayjsUnit.Second) / 3600

        let velocidad = distancia / tiempo

        puntos[i].VELOCIDAD = Math.trunc(velocidad)
      }
    }
    deferred.resolve(puntos)
  } catch (err) {
    VueInst.$log.error(err)
  }

  return deferred.promise
}

function toRadians (degrees) {
  return (degrees * Math.PI) / 180
}

function toDegrees (radians) {
  return (radians * 180) / Math.PI
}
function calcularRumboX (startLat, startLng, destLat, destLng) {
  // TODO: hacer en backend
  startLat = toRadians(startLat)
  startLng = toRadians(startLng)
  destLat = toRadians(destLat)
  destLng = toRadians(destLng)

  let x =
    Math.cos(startLat) * Math.sin(destLat) -
    Math.sin(startLat) * Math.cos(destLat) * Math.cos(destLng - startLng)
  let brng = toDegrees(x)
  return (brng + 360) % 360
}
function calcularRumboY (startLat, startLng, destLat, destLng) {
  // TODO: hacer en backend
  startLat = toRadians(startLat)
  startLng = toRadians(startLng)
  destLat = toRadians(destLat)
  destLng = toRadians(destLng)

  let y = Math.sin(destLng - startLng) * Math.cos(destLat)
  let brng = toDegrees(y)
  return (brng + 360) % 360
}
function calcularRumbo (startLat, startLng, destLat, destLng) {
  // TODO: hacer en backend
  startLat = toRadians(startLat)
  startLng = toRadians(startLng)
  destLat = toRadians(destLat)
  destLng = toRadians(destLng)

  let y = Math.sin(destLng - startLng) * Math.cos(destLat)
  let x =
    Math.cos(startLat) * Math.sin(destLat) -
    Math.sin(startLat) * Math.cos(destLat) * Math.cos(destLng - startLng)
  let brng = Math.atan2(y, x)
  brng = toDegrees(brng)
  return (brng + 360) % 360
}
// #endregion

// #region PLANES_OPERACIONES
let planOpSVM = null

export const initPlanOperacionesSketchViewModel = async function (data) {
  try {
    const [SketchViewModel] = await loadModules([
      'esri/widgets/Sketch/SketchViewModel'
    ])
    let callbackCreate = data.callbackCreate
    let callbackUpdate = data.callbackUpdate
    let callbackDelete = data.callbackDelete

    let layer = map.findLayerById('layer-plan-operaciones')

    planOpSVM = new SketchViewModel({
      view: mapView,
      layer: layer
    })
    planOpSVM.on(['create', 'delete', 'update'], async (evt) => {
      // Arrow logic
      if (
        isDrawingArrow &&
        evt.type === 'create' &&
        evt.graphic &&
        evt.graphic.geometry.type === 'polyline'
      ) {
        if (evt.state === 'active') {
          if (evt.graphic.geometry.paths[0].length === 3) {
            // Si esta dibujando flecha y tiene 3 puntos (2 reales) terminar el dibujo
            planOpSVM.complete()
          }
        }
      }

      if (evt.state === 'complete' && evt.type === 'create') {
        // Crear grafico
        let attributes = {
          ID_GRAFICO: VueInst.$uuid.createUUID()
        }

        evt.graphic.attributes = JSON.parse(JSON.stringify(attributes)) // Hack para quitar el __observer__ que causa un bucle infinito a arcgis
        let arrowColor = [
          Math.floor(Math.random() * 255),
          Math.floor(Math.random() * 255),
          Math.floor(Math.random() * 255)
        ]

        let geometry
        let type = evt.graphic.geometry.type
        let symbol
        if (
          evt.graphic.geometry.type === 'point' &&
          evt.graphic.symbol.type === 'simple-marker'
        ) {
          // Punto
          // console.log('Punto')
          let defaultSymbol = planOpSVM.pointSymbol

          geometry = [evt.graphic.geometry.x, evt.graphic.geometry.y]
          symbol = {
            type: defaultSymbol.type,
            color: defaultSymbol.color,
            // 'angle': defaultSymbol.angle,
            size: defaultSymbol.size,
            style: defaultSymbol.style
          }
        } else if (
          evt.graphic.geometry.type === 'point' &&
          evt.graphic.symbol.type === 'picture-marker'
        ) {
          // Icono
          // console.log('Icono')
          let defaultSymbol = planOpSVM.pointSymbol
          attributes.LABEL = {
            label: defaultSymbol.label,
            src: defaultSymbol.url
          }

          geometry = [evt.graphic.geometry.x, evt.graphic.geometry.y]

          type = 'icon'

          // Simbolo que añade una circunferencia al icono, en caso de ser medio externo
          // mediante la variable 'tipoLinea' para reutilizar
          symbol = {
            type: 'cim',
            // CIM Line Symbol
            data: {
              type: 'CIMSymbolReference',
              symbol: {
                type: 'CIMPointSymbol',
                symbolLayers: [
                  {
                    // arrow symbol
                    type: 'CIMVectorMarker',
                    enable: tipoLinea,
                    size: 30,
                    frame: {
                      xmin: 2.5,
                      ymin: 2.5,
                      xmax: 14,
                      ymax: 14
                    },
                    markerGraphics: [
                      {
                        type: 'CIMMarkerGraphic',
                        geometry: {
                          rings: [
                            [
                              [8.5, 0.2],
                              [7.06, 0.33],
                              [5.66, 0.7],
                              [4.35, 1.31],
                              [3.16, 2.14],
                              [2.14, 3.16],
                              [1.31, 4.35],
                              [0.7, 5.66],
                              [0.33, 7.06],
                              [0.2, 8.5],
                              [0.33, 9.94],
                              [0.7, 11.34],
                              [1.31, 12.65],
                              [2.14, 13.84],
                              [3.16, 14.86],
                              [4.35, 15.69],
                              [5.66, 16.3],
                              [7.06, 16.67],
                              [8.5, 16.8],
                              [9.94, 16.67],
                              [11.34, 16.3],
                              [12.65, 15.69],
                              [13.84, 14.86],
                              [14.86, 13.84],
                              [15.69, 12.65],
                              [16.3, 11.34],
                              [16.67, 9.94],
                              [16.8, 8.5],
                              [16.67, 7.06],
                              [16.3, 5.66],
                              [15.69, 4.35],
                              [14.86, 3.16],
                              [13.84, 2.14],
                              [12.65, 1.31],
                              [11.34, 0.7],
                              [9.94, 0.33],
                              [8.5, 0.2]
                            ]
                          ]
                        },
                        symbol: {
                          // black fill for the arrow symbol
                          type: 'CIMPolygonSymbol',
                          symbolLayers: [
                            {
                              type: 'CIMSolidStroke', // CIMSolidFill | CIMSolidStroke
                              enable: true,
                              width: 2,
                              color: [10, 10, 10, 255]
                            }
                          ]
                        }
                      }
                    ]
                  },
                  {
                    type: 'CIMPictureMarker',
                    enable: true,
                    url: defaultSymbol.url,
                    size: 40 // 60
                  }
                ]
              }
            }
          }
          evt.graphic.symbol = symbol
        } else if (
          evt.graphic.geometry.type === 'point' &&
          evt.graphic.symbol.type === 'text'
        ) {
          // Texto
          let defaultSymbol = planOpSVM.pointSymbol

          geometry = [evt.graphic.geometry.x, evt.graphic.geometry.y]
          type = 'text'
          symbol = {
            type: 'text',
            color: defaultSymbol.arrowColor,
            text: defaultSymbol.text,
            xoffset: 0,
            yoffset: 0,
            haloColor: 'white',
            haloSize: '20px',
            font: {
              size: defaultSymbol.font.size,
              family: 'Arial Unicode MS',
              weight: 'bold'
            }
          }
        } else if (
          !isDrawingArrow &&
          evt.graphic.geometry.type === 'polyline'
        ) {
          // Linea
          if (!tipoLinea) {
            // Lineas antiguas
            let defaultSymbol = planOpSVM.polylineSymbol

            geometry = evt.graphic.geometry.paths[0]
            symbol = {
              type: defaultSymbol.type,
              color: defaultSymbol.color,
              width: defaultSymbol.width,
              style: defaultSymbol.style,
              join: defaultSymbol.join,
              miterLimit: defaultSymbol.miterLimit
            }
          } else {
            // Lineas nuevas
            let g = await makeCustomLine(
              evt.graphic.geometry.paths[0],
              tipoLinea
            )

            geometry = evt.graphic.geometry.paths[0]
            evt.graphic.symbol = g.symbol
            symbol = g.symbol
          }
          attributes.LABEL = planOpSVM.polylineSymbol.label
        } else if (isDrawingArrow || evt.graphic.geometry.type === 'polygon') {
          // Poligonos y flecha
          if (!tipoLinea) {
            // Poligonos y flechas old
            let defaultSymbol = planOpSVM.polygonSymbol

            if (isDrawingArrow) {
              // Convertir la linea a flecha y crear el graphic
              isDrawingArrow = false
              let g = await makeArrow(
                evt.graphic.geometry.paths[0],
                defaultSymbol.color
              )
              evt.graphic.geometry = g.geometry
              evt.graphic.symbol = g.symbol
              type = 'polygon'
            }

            geometry = evt.graphic.geometry.rings[0]
            symbol = {
              type: defaultSymbol.type,
              color: defaultSymbol.color,
              style: defaultSymbol.style,
              outline: {
                color: defaultSymbol.outline.color,
                width: defaultSymbol.outline.width
              }
            }
          } else {
            // New poligons
            let g = await makeCustomPolygon(
              evt.graphic.geometry.rings[0],
              tipoLinea
            )

            geometry = evt.graphic.geometry.rings[0]

            evt.graphic.geometry = g.geometry
            evt.graphic.symbol = g.symbol
            // type = 'polyline'
            type = 'polygon'
            symbol = g.symbol
          }

          attributes.LABEL = planOpSVM.polygonSymbol.label
        }

        let graphic = {
          // TODO: poner los mismos nombres que en BBDD y cambiar en backend en (plan_operaciones addGraphics)
          attributes: attributes,
          coordenadas: geometry,
          type: type,
          symbol: symbol
        }

        callbackCreate(graphic)
      } else if (evt.state === 'complete' && evt.type === 'update') {
        // Actualizar grafico
        let graphic = evt.graphics[0]
        let geom = graphic.geometry

        let newGeometryGraphic
        if (geom.type === 'point') {
          newGeometryGraphic = [geom.x, geom.y]
        } else if (geom.type === 'polyline') {
          newGeometryGraphic = geom.paths[0]
        } else if (geom.type === 'polygon') {
          newGeometryGraphic = geom.rings[0]
        }

        // geometry.type = graphic.geometry.type
        let newGraphic = {
          ATRIBUTOS: graphic.attributes,
          GEOMETRIA: newGeometryGraphic
        }

        callbackUpdate(newGraphic)
      } else if (evt.type === 'delete') {
        // Borrar grafico
        callbackDelete(evt.graphics[0].attributes.ID_GRAFICO)
      }
    })
  } catch (err) {
    VueInst.$log.error(err)
  }
}

export const paintEventPlanOperaciones = (event) => {
  let typeEvent = event.function
  let symbolColor = event.color ? event.color : [255, 0, 0, 0.5]

  isDrawingArrow = false
  tipoLinea = undefined

  if (typeEvent === 'cancel') {
    planOpSVM.cancel()
  } else if (typeEvent === 'point') {
    planOpSVM.pointSymbol = {
      type: 'simple-marker',
      style: 'circle',
      color: symbolColor,
      size: '16px',
      outline: {
        color: symbolColor,
        width: 3
      }
    }
  } else if (typeEvent === 'polyline') {
    if (event.custom) {
      tipoLinea = event.type_line
    } else {
      planOpSVM.polylineSymbol.color = symbolColor
      planOpSVM.polylineSymbol.style = event.type_line
        ? event.type_line
        : 'solid'
    }
    planOpSVM.polylineSymbol.label = event.labelPolyline
  } else if (typeEvent === 'polygon') {
    if (event.custom) {
      tipoLinea = event.type_polygon
    } else {
      planOpSVM.polygonSymbol.color = symbolColor
      planOpSVM.polygonSymbol.outline = {
        color: symbolColor,
        width: 2
      }
    }
    planOpSVM.polygonSymbol.label = event.labelPolygon
  } else if (typeEvent === 'icon') {
    typeEvent = 'point'
    tipoLinea = event.medio_externo
    planOpSVM.pointSymbol = {
      type: 'picture-marker',
      url: event.src,
      label: event.label,
      width: '35px',
      height: '35px'
    }
  } else if (typeEvent === 'text') {
    typeEvent = 'point'
    planOpSVM.pointSymbol = {
      type: 'text',
      color: symbolColor,
      text: event.text,
      xoffset: 0,
      yoffset: 0,
      haloColor: 'white',
      haloSize: '20px',
      font: {
        size: event.size,
        family: 'Arial Unicode MS',
        weight: 'bold'
      }
    }
  } else if (typeEvent === 'arrow') {
    typeEvent = 'polyline'
    isDrawingArrow = true

    planOpSVM.polygonSymbol.color = symbolColor
    planOpSVM.polygonSymbol.outline.color = symbolColor
  }
  planOpSVM.create(typeEvent)
}

export const stopPlanOperacionesSketchViewModel = function () {
  if (planOpSVM == null) return
  let layer = map.findLayerById('layer-plan-operaciones')
  layer.removeAll()

  planOpSVM.cancel()
  planOpSVM.destroy()
}

let isDrawingArrow = false
let tipoLinea
// Crea un poligono con forma de flecha a partir de una linea de dos puntos
async function makeArrow (geom, color) {
  let deferred = Q.defer()

  try {
    const [Point, Polygon, Graphic, GeometryEngine] = await loadModules([
      'esri/geometry/Point',
      'esri/geometry/Polygon',
      'esri/Graphic',
      'esri/geometry/geometryEngine'
    ])

    const start = new Point({ x: geom[0][0], y: geom[0][1] })
    const end = new Point({ x: geom[1][0], y: geom[1][1] })

    const dist = start.distance(end)
    const dy = end.y - start.y
    const dx = end.x - start.x
    let rads = Math.atan2(dx, dy)

    if (rads < 0) {
      rads = Math.abs(rads)
    } else {
      rads = 2 * Math.PI - rads
    }

    const degrees = (rads * 180) / Math.PI

    const width = 0.2 * dist // 1/5, can adjust

    const bottomLeft = [start.x - width / 10, start.y]
    const bottomRight = [start.x + width / 10, start.y]
    const midLeft = [bottomLeft[0], [bottomLeft[1] + dist - width]]
    const midRight = [bottomRight[0], [bottomRight[1] + dist - width]]
    const edgeLeft = [midLeft[0] - width / 2, midLeft[1]]
    const edgeRight = [midRight[0] + width / 2, midRight[1]]
    const point = [start.x, start.y + dist]

    const rings = [
      point,
      edgeLeft,
      midLeft,
      bottomLeft,
      bottomRight,
      midRight,
      edgeRight
    ]

    const poly = new Polygon({
      rings: [rings],
      spatialReference: { wkid: 102100 }
    })

    const rotatedPoly = GeometryEngine.rotate(poly, degrees, start)
    const symbol = {
      type: 'simple-fill',
      color: color,
      outline: {
        color: color,
        width: '2'
      }
    }

    deferred.resolve(
      new Graphic({
        geometry: rotatedPoly,
        symbol
      })
    )
  } catch (err) {
    deferred.reject(err)
    VueInst.$log.error(err)
  }

  return deferred.promise
}

// Crea una linea custom
// url: Es el tipo de linea seleccionado por el usuario
async function makeCustomLine (geom, url) {
  let deferred = Q.defer()

  try {
    const [Graphic, Polyline] = await loadModules([
      'esri/Graphic',
      'esri/geometry/Polyline'
    ])

    const poly = new Polyline({
      paths: geom,
      spatialReference: { wkid: 102100 }
    })

    const symbol = symbology[url]
    deferred.resolve({
      geometry: poly,
      symbol
    })
  } catch (err) {
    deferred.reject(err)
    VueInst.$log.error(err)
  }

  return deferred.promise
}

async function makeCustomPolygon (geom, url) {
  let deferred = Q.defer()

  try {
    const [Polygon, Graphic] = await loadModules([
      'esri/geometry/Polygon',
      'esri/Graphic'
    ])

    const poly = new Polygon({
      rings: geom,
      spatialReference: { wkid: 102100 }
    })
    const symbol = symbology[url]
    deferred.resolve({
      geometry: poly,
      symbol
    })
  } catch (err) {
    deferred.reject(err)
    VueInst.$log.error(err)
  }

  return deferred.promise
}

async function createGraphicsDraw (graphicList) {
  let deferred = Q.defer()

  try {
    const [Graphic, Point, Polyline, Polygon, GeometryEngine] =
      await loadModules([
        'esri/Graphic',
        'esri/geometry/Point',
        'esri/geometry/Polyline',
        'esri/geometry/Polygon',
        'esri/geometry/geometryEngine'
      ])

    let graphicsDraw = graphicList
    let geometry
    let graphics = []
    for (let i = 0; i < graphicsDraw.length; i++) {
      let tipo = graphicsDraw[i].type || graphicsDraw[i].TIPO // TODO: esto no mola
      let coords = graphicsDraw[i].coordenadas || graphicsDraw[i].GEOMETRIA
      let simbolo = graphicsDraw[i].symbol || graphicsDraw[i].SIMBOLO
      let atributos = graphicsDraw[i].attributes || graphicsDraw[i].ATRIBUTOS
      atributos = JSON.parse(JSON.stringify(atributos)) // HACK __observer__

      if (tipo === 'point' || tipo === 'icon' || tipo === 'text') {
        geometry = new Point({
          x: coords[0],
          y: coords[1],
          spatialReference: { wkid: 3857 }
        })
      } else if (tipo === 'polyline') {
        geometry = new Polyline({
          hasZ: false,
          hasM: true,
          paths: coords,
          spatialReference: { wkid: 3857 }
        })

        atributos.LONGITUD = GeometryEngine.geodesicLength(geometry)
      } else if (tipo === 'polygon') {
        geometry = new Polygon({
          hasZ: false,
          hasM: true,
          rings: coords,
          spatialReference: { wkid: 3857 }
        })

        atributos.LONGITUD = GeometryEngine.geodesicLength(geometry)
        atributos.AREA = Math.abs(GeometryEngine.geodesicArea(geometry))
      }

      let graphic = new Graphic({
        geometry: geometry,
        symbol: simbolo,
        attributes: atributos
      })
      graphics.push(graphic)
    }

    deferred.resolve(graphics)
  } catch (err) {
    VueInst.$log.error(err)
  }

  return deferred.promise
}
function sortGraphics (graphics) {
  return graphics.sort((a, b) => {
    if (a.geometry.type === 'point') {
      return 1
    }
    if (b.geometry.type === 'point') {
      return -1
    }
    if (a.geometry.type === 'polyline' && b.geometry.type === 'polygon') {
      return 1
    }
    if (b.geometry.type === 'polyline' && a.geometry.type === 'polygon') {
      return -1
    }
    return 1
  })
}

export const drawGraphicsPlanOperaciones = async function (graphicList) {
  let deferred = Q.defer()

  let layer = map.findLayerById('layer-plan-operaciones')
  layer.removeAll()

  let graphics = await createGraphicsDraw(graphicList)
  let graphicsSorted = sortGraphics(graphics)
  layer.addMany(graphicsSorted)

  deferred.resolve()

  return deferred.promise
}
// #endregion

// #region PERIMETROS ********************************************************************************************************************************************************************
let planPSVM = null
let colorPerimetro = [255, 10, 10, 255]
let displayCoords
let archivoQML = null
const R = 6378137.0

export const initPerimetroSketchViewModel = async function (data) {
  try {
    const [SketchViewModel] = await loadModules([
      'esri/widgets/Sketch/SketchViewModel'
    ])
    let callbackCreate = data.callbackCreate
    let callbackUpdate = data.callbackUpdate
    let callbackDelete = data.callbackDelete

    let layer = map.findLayerById('layer-perimetros')

    planPSVM = new SketchViewModel({
      view: mapView,
      layer: layer
    })
    planPSVM.on(['create', 'delete', 'update'], async (evt) => {
      if (
        evt.type === 'create' &&
        evt.graphic &&
        evt.graphic.geometry.type === 'polyline'
      ) {
        if (evt.state === 'active') {
          if (evt.graphic.geometry.paths[0].length === 3) {
            // Si esta dibujando flecha y tiene 3 puntos (2 reales) terminar el dibujo
            planPSVM.complete()
          }
        }
      }

      if (evt.state === 'complete' && evt.type === 'create') {
        // Crear grafico
        let attributes = {
          ID_GRAFICO: VueInst.$uuid.createUUID()
        }

        evt.graphic.attributes = JSON.parse(JSON.stringify(attributes)) // Hack para quitar el __observer__ que causa un bucle infinito a arcgis
        let geometry
        let type = evt.graphic.geometry.type
        let symbol

        if (type === 'polygon') {
          let g = await makeCustomPolygon(
            evt.graphic.geometry.rings[0],
            tipoLineaPerimetro
          )

          cambiarColor(g.symbol)
          geometry = evt.graphic.geometry

          evt.graphic.geometry = g.geometry
          evt.graphic.symbol = g.symbol
          type = 'polygon'
          symbol = g.symbol

          attributes.LABEL = planPSVM.polygonSymbol.label
        }

        let graphic = {
          // TODO: poner los mismos nombres que en BBDD y cambiar en backend en (plan_operaciones addGraphics)
          attributes: attributes,
          geometry: geometry,
          type: type,
          symbol: symbol
        }
        callbackCreate(graphic)
      } else if (evt.state === 'complete' && evt.type === 'update') {
        // Actualizar grafico
        let graphic = evt.graphics[0]

        let newGraphic = {
          attributes: graphic.attributes,
          geometry: graphic.geometry
        }

        callbackUpdate(newGraphic)
      } else if (evt.type === 'delete') {
        // Borrar grafico
        callbackDelete(evt.graphics[0].attributes.ID_GRAFICO)
      }
    })
  } catch (err) {
    VueInst.$log.error(err)
  }
}
const cambiarColor = (objeto) => {
  for (let key in objeto) {
    if (key === 'color') {
      objeto[key] = colorPerimetro
    } else if (typeof objeto[key] === 'object') {
      cambiarColor(objeto[key])
    }
  }
}
let tipoLineaPerimetro
export const paintEventPerimetro = (event) => {
  let typeEvent = event.function

  tipoLineaPerimetro = undefined
  colorPerimetro = [255, 10, 10, 255]

  if (typeEvent === 'cancel') {
    planPSVM.cancel()
  } else if (typeEvent === 'polygon') {
    if (event.custom) {
      colorPerimetro = event.color
      // Esto es para pasar de gamma de 0-1 a 0-255
      colorPerimetro[3] *= 255
      tipoLineaPerimetro = event.type_line // aunque funcione como polígono, todo viene desde una línea
      event.label.color = event.color
      planPSVM.polygonSymbol.label = event.label
    }
  }
  planPSVM.create(typeEvent)
}

export const stopPerimeterSketchViewModel = function () {
  if (planPSVM == null) return
  let layer = map.findLayerById('layer-perimetros')
  layer.removeAll()

  planPSVM.cancel()
  planPSVM.destroy()
}

async function createGraphicsDrawPerimeter (graphicList) {
  let deferred = Q.defer()

  try {
    const [Graphic, Polygon, Point, Polyline] =
      await loadModules([
        'esri/Graphic',
        'esri/geometry/Polygon',
        'esri/geometry/Point',
        'esri/geometry/Polyline'
      ])

    let graphicsDrawPerimetro = graphicList
    let geometry
    let graphics = []

    for (let i = 0; i < graphicsDrawPerimetro.length; i++) {
      let tipo = graphicsDrawPerimetro[i].type
      let coords = graphicsDrawPerimetro[i].geometry
      let simbolo = graphicsDrawPerimetro[i].symbol
      let atributos = graphicsDrawPerimetro[i].attributes
      const individual = await measurePerimetros([graphicsDrawPerimetro[i]])

      Object.assign(atributos, {
        AREA: individual.area,
        PERIMETRO: individual.perimetro
      })

      atributos = JSON.parse(JSON.stringify(atributos)) // HACK __observer__
      if (tipo === 'polygon') {
        geometry = new Polygon({
          hasZ: false,
          hasM: true,
          rings: coords.rings[0],
          spatialReference: { wkid: 3857 }
        })
      }

      if (tipo === 'point') {
        geometry = new Point({
          latitude: coords.y,
          longitude: coords.x,
          spatialReference: { wkid: 3857 }
        })
      }

      if (tipo === 'polyline') {
        geometry = new Polyline({
          hasZ: false,
          hasM: true,
          paths: coords.paths,
          spatialReference: { wkid: 3857 }
        })
      }

      const is3D = store.getters['map/isMap3D']
      if (is3D && tipo === 'polygon') {
        const outline = simbolo.data.symbol.symbolLayers.find(symbolLayer => 'color' in symbolLayer)

        if (atributos.LABEL.style === 'perimetroActivo') {
          simbolo = {
            type: 'simple-fill',
            color: [outline.color[0], outline.color[1], outline.color[2], 0.01],
            outline: {
              color: outline.color,
              width: outline.width
            }
          }
        }
        if (atributos.LABEL.style === 'perimetroEstabilizado') {
          simbolo = {
            type: 'simple-fill',
            color: [outline.color[0], outline.color[1], outline.color[2], 0.01],
            outline: {
              color: outline.color,
              width: outline.width
            }
          }

          let rings = coords.rings
          let numDivisions = 30
          let lineLength = 50

          let lineSymbolLayer = {
            type: 'polygon-3d',
            symbolLayers: [{
              type: 'line',
              size: outline.width,
              material: {
                color: outline.color
              }
            }]
          }

          rings.forEach(function (path) {
            for (let i = 0; i < path.length - 1; i++) {
              let startPoint = path[i]
              let endPoint = path[i + 1]

              // Calcular la longitud del segmento
              let dx = endPoint[0] - startPoint[0]
              let dy = endPoint[1] - startPoint[1]
              let segmentLength = Math.sqrt(dx * dx + dy * dy)

              // Dividir el segmento en divisiones iguales
              for (let j = 0; j < numDivisions; j++) {
                let fraction = j / numDivisions
                let midPoint = [
                  startPoint[0] + fraction * dx,
                  startPoint[1] + fraction * dy,
                  startPoint[2] + fraction * (endPoint[2] - startPoint[2])
                ]

                // Dirección perpendicular
                let unitDx = dx / segmentLength
                let unitDy = dy / segmentLength
                let offsetX = -unitDy * lineLength
                let offsetY = unitDx * lineLength

                // Crear la línea perpendicular
                let linePath = [
                  [midPoint[0] - offsetX, midPoint[1] - offsetY, midPoint[2]],
                  [midPoint[0] + offsetX, midPoint[1] + offsetY, midPoint[2]]
                ]

                let line = new Polygon({
                  hasZ: false,
                  hasM: true,
                  rings: [linePath],
                  spatialReference: { wkid: 3857 }
                })

                let lineGraphic = new Graphic({
                  geometry: line,
                  symbol: lineSymbolLayer,
                  attributes: atributos
                })

                graphics.push(lineGraphic)
              }
            }
          })

          // simbolo = {
          // type: 'polygon-3d',
          // symbolLayers: [
          //  {
          //    type: 'fill',
          //    material: {
          //      color: [outline.color.r, outline.color.g, outline.color.b, 0.01]
          //    },
          //    outline: {
          //      color: outline.color,
          //      size: outline.width
          //    }
          //  },
          //  {
          //    type: 'line',
          //    material: { color: outline.color },
          //    size: 10, // Ancho de las líneas perpendiculares
          //    cap: 'round',
          //    join: 'round',
          //    pattern: {
          //      type: 'style',
          //      style: 'dash',
          //      size: 20 // Tamaño del patrón (ajusta según lo que necesites)
          //    }
          //  }
          // ]
          // }
        }

        if (atributos.LABEL.style === 'perimetroPotencial') {
          simbolo = {
            type: 'simple-fill',
            color: [outline.color[0], outline.color[1], outline.color[2], 0.01],
            outline: {
              type: 'simple-line',
              color: outline.color,
              width: outline.width,
              style: 'long-dash'
            }
          }
        }
      }

      let graphic = new Graphic({
        geometry: geometry,
        symbol: simbolo,
        attributes: atributos
      })
      graphics.push(graphic)
    }
    deferred.resolve(graphics)
  } catch (err) {
    VueInst.$log.error(err)
  }

  return deferred.promise
}

async function perimeterGeoJsonToGraphicsPerimeter (geojson, isPerimeter) {
  const deferred = Q.defer()

  try {
    const [Polygon, Polyline, Point] =
      await loadModules([
        'esri/geometry/Polygon',
        'esri/geometry/Polyline',
        'esri/geometry/Point'
      ])

    let geometry
    const graphics = []
    let forma
    let simbolo

    switch (geojson.features[0].geometry.type.toLowerCase()) {
      case 'multipolygon':
        displayCoords = geojson.features[0].geometry.coordinates[0][0][0]
        break
      case 'point':
        displayCoords = geojson.features[0].geometry.coordinates
        break
      case 'polygon':
        displayCoords = geojson.features[0].geometry.coordinates[0][0]
        break
      case 'geometrycollection':
        displayCoords = geojson.features[0].geometry.geometries[0].coordinates[0][0]
        break
      default:
        displayCoords = null
    }

    if (isLatLon(displayCoords[0], displayCoords[1])) {
      displayCoords = changeCoords(displayCoords, 'point')
    }

    for (let i = 0; i < geojson.features.length; i++) {
      if (!geojson.features[i].geometry) {
        continue
      }

      let tipo = geojson.features[i].geometry.type.toLowerCase()
      const coords = changeCoords(geojson.features[i].geometry.coordinates, tipo)
      const atributos = geojson.features[i].properties
      let colorDefault = [Math.floor(Math.random() * 256), Math.floor(Math.random() * 256), Math.floor(Math.random() * 256), 0.5]

      if (tipo === 'polygon') {
        geometry = new Polygon({
          hasZ: false,
          hasM: true,
          rings: coords,
          spatialReference: { wkid: 3857 }
        })

        forma = await crearPoligonoPerimetro(geometry)

        if (isPerimeter) {
          colorDefault = [0, 0, 0, 0]
          forma.symbol.color = colorDefault
          forma.symbol.outline.color = [255, 0, 0, 255]
        } else {
          if (atributos.fill) {
            forma.symbol.color = hexToBytes(atributos.fill.substring(1))
          } else {
            if (archivoQML) {
              const categoriasQML = [...archivoQML.getElementsByTagName('category')].map(cat => ({
                value: cat.getAttribute('value'),
                symbol: cat.getAttribute('symbol')
              }))
              const simbolosQML = getSymbols(archivoQML)

              forma.symbol.color = getCoords(atributos.Elapsed_Mi, categoriasQML, simbolosQML)
            } else {
              forma.symbol.color = colorDefault
            }
          }
        }

        simbolo = forma.symbol
      }

      if (tipo === 'multipolygon') {
        for (let j = 0; j < coords.length; j++) {
          geometry = new Polygon({
            hasZ: false,
            hasM: true,
            rings: coords[j],
            spatialReference: { wkid: 3857 }
          })

          forma = await crearPoligonoPerimetro(geometry)

          if (isPerimeter) {
            colorDefault = [0, 0, 0, 0]
            forma.symbol.color = colorDefault
            forma.symbol.outline.color = [255, 0, 0, 255]
          } else {
            if (atributos.fill) {
              forma.symbol.color = hexToBytes(atributos.fill.substring(1))
            } else {
              if (archivoQML) {
                const categoriasQML = [...archivoQML.getElementsByTagName('category')].map(cat => ({
                  value: cat.getAttribute('value'),
                  symbol: cat.getAttribute('symbol')
                }))
                const simbolosQML = getSymbols(archivoQML)

                forma.symbol.color = getCoords(atributos.Elapsed_Mi, categoriasQML, simbolosQML)
              } else {
                forma.symbol.color = colorDefault
              }
            }
          }

          simbolo = forma.symbol

          atributos.ID_GRAFICO = VueInst.$uuid.createUUID()
          const graphic = {
            attributes: atributos,
            geometry,
            type: 'polygon',
            symbol: simbolo
          }

          graphics.push(graphic)
        }
      }

      if (tipo === 'point') {
        geometry = new Point({
          longitude: coords[0],
          latitude: coords[1],
          coords
        })

        forma = await crearPuntoPerimetro(geometry)

        if (atributos.fill) {
          forma.symbol.color = hexToBytes(atributos.fill.substring(1))
        } else {
          forma.symbol.color = colorDefault
        }

        simbolo = forma.symbol
      }

      if (tipo === 'linestring' || tipo === 'polyline') {
        geometry = new Polyline({
          hasZ: false,
          hasM: true,
          paths: coords,
          spatialReference: { wkid: 3857 }
        })

        forma = await crearLineaPerimetro(geometry)

        if (atributos.fill) {
          forma.symbol.color = hexToBytes(atributos.fill.substring(1))
        } else {
          forma.symbol.color = colorDefault
        }

        simbolo = forma.symbol
        tipo = geometry.type
      }
      atributos.ID_GRAFICO = VueInst.$uuid.createUUID()
      const graphic = {
        attributes: atributos,
        geometry,
        type: tipo,
        symbol: simbolo
      }
      graphics.push(graphic)
    }
    deferred.resolve(graphics)
  } catch (err) {
    VueInst.$log.error(err)
  }

  return deferred.promise
}

function changeCoords (coords, tipo) {
  let coordX
  let coordY

  if (tipo === 'multipolygon' || tipo === 'polygon' || tipo === 'linestring' || tipo === 'polyline') {
    for (let i = 0; i < coords.length; i++) {
      for (let j = 0; j < coords[i].length; j++) {
        if (!(typeof (coords[i][j][0]) === 'number')) {
          for (let z = 0; z < coords[i][j].length; z++) {
            coordX = coords[i][j][z][0]
            coordY = coords[i][j][z][1]

            if (isLatLon(coordX, coordY)) {
              const coordXFixed = R * coordX * Math.PI / 180
              const coordYFixed = R * Math.log(Math.tan(Math.PI / 4 + (coordY * Math.PI / 180) / 2))

              coords[i][j][z][0] = coordXFixed
              coords[i][j][z][1] = coordYFixed
            }
          }
        } else {
          coordX = coords[i][j][0]
          coordY = coords[i][j][1]

          if (isLatLon(coordX, coordY)) {
            const coordXFixed = R * coordX * Math.PI / 180
            const coordYFixed = R * Math.log(Math.tan(Math.PI / 4 + (coordY * Math.PI / 180) / 2))

            coords[i][j][0] = coordXFixed
            coords[i][j][1] = coordYFixed
          }
        }
      }
    }
  } else if (tipo === 'point') {
    coordX = coords[0]
    coordY = coords[1]

    if (isLatLon(coordX, coordY)) {
      const coordXFixed = R * coordX * Math.PI / 180
      const coordYFixed = R * Math.log(Math.tan(Math.PI / 4 + (coordY * Math.PI / 180) / 2))

      coords[0] = coordXFixed
      coords[1] = coordYFixed
    }
  }

  return coords
}

export function isLatLon (lon, lat) {
  return (
    lon >= -180 && lon <= 180 &&
    lat >= -90 && lat <= 90
  )
}

function getSymbols (archivoQML) {
  const symbols = []

  const symbolNodes = archivoQML.getElementsByTagName('symbol')

  for (let i = 0; i < symbolNodes.length; i++) {
    const symbol = symbolNodes[i]
    const name = symbol.getAttribute('name')
    const type = symbol.getAttribute('type')

    const layers = []
    const layerNodes = symbol.getElementsByTagName('layer')

    for (let j = 0; j < layerNodes.length; j++) {
      const layer = layerNodes[j]
      const layerClass = layer.getAttribute('class')

      const props = {}
      const optionContainers = layer.getElementsByTagName('Option')

      for (let k = 0; k < optionContainers.length; k++) {
        const optionGroup = optionContainers[k]

        if (optionGroup.getAttribute('type') === 'Map') {
          const innerOptions = optionGroup.getElementsByTagName('Option')

          for (let m = 0; m < innerOptions.length; m++) {
            const opt = innerOptions[m]
            const key = opt.getAttribute('name')
            const value = opt.getAttribute('value')
            if (key && value !== null) {
              props[key] = value
            }
          }
        }
      }

      layers.push({
        class: layerClass,
        props
      })
    }

    symbols.push({
      name,
      type,
      layers
    })
  }

  return symbols
}

function getCoords (elapsedmi, categorias, simbolos) {
  let index
  for (let i = 0; i < categorias.length; i++) {
    if (categorias[i].value === elapsedmi.toString()) {
      index = categorias[i].symbol
      break
    }
  }

  let colorQML
  for (let j = 0; j < simbolos.length; j++) {
    if (index === simbolos[j].name) {
      colorQML = simbolos[j].layers[0].props.color
      break
    }
  }

  const colorFinal = []
  colorFinal[0] = parseInt(colorQML.substring(0, colorQML.indexOf('r') - 1).split(',')[0])
  colorFinal[1] = parseInt(colorQML.substring(0, colorQML.indexOf('r') - 1).split(',')[1])
  colorFinal[2] = parseInt(colorQML.substring(0, colorQML.indexOf('r') - 1).split(',')[2])
  colorFinal[3] = parseInt(colorQML.substring(0, colorQML.indexOf('r') - 1).split(',')[3])

  return colorFinal
}

export const drawGraphicsPerimetro = async function (graphicList) {
  let deferred = Q.defer()
  let layer = map.findLayerById('layer-perimetros')
  closeMapPopups()
  let graphics = await createGraphicsDrawPerimeter(graphicList)
  // layer.removeAll()
  layer.addMany(graphics)
  deferred.resolve()

  return deferred.promise
}

export const removeGraphicsPerimetro = async function (graphicList) {
  let deferred = Q.defer()
  let layer = map.findLayerById('layer-perimetros')
  closeMapPopups()

  let list = graphicList.map(graphic => graphic.attributes.ID_GRAFICO)
  let graphics = layer.graphics.items.filter(graphic => list.includes(graphic.attributes.ID_GRAFICO))
  layer.removeMany(graphics)

  deferred.resolve()

  return deferred.promise
}

export const getIncendioVisiblePerimetros = async function (graphics) {
  try {
    let deferred = Q.defer()

    let layerID = map.findLayerById('layer-perimetros')
    let array = []

    graphics.forEach(async (graphic) => {
      if (layerID.title === 'Gráficos Perímetros' && layerID.graphics.length > 0) {
        for (const layerGraphic of layerID.graphics) {
          const intersects = await intersectGraphic(layerGraphic, graphic)
          if (intersects) {
            array.push(layerGraphic)
          }
        }
      } else {
        deferred.resolve([])
      }
      deferred.resolve(array)
    })
    return deferred.promise
  } catch (err) {
    VueInst.$log.error(err)
  }
}

// #region CREACION DE FORMAS
async function crearPuntoPerimetro (geometry) {
  let forma = {
    coordenadas: {
      longitude: geometry.longitude,
      latitude: geometry.latitude
    },
    symbol: {
      type: 'simple-marker',
      color: [Math.floor(Math.random() * 256), Math.floor(Math.random() * 256), Math.floor(Math.random() * 256), 0.5],
      size: 6,
      outline: {
        type: 'simple-line',
        color: [50, 50, 50, 255],
        width: 1,
        style: 'solid'
      }
    }
  }
  return forma
}

async function crearPoligonoPerimetro (geometry) {
  let forma = {
    aggregateGeometries: null,
    geometry: geometry,
    symbol: {
      type: 'simple-fill',
      color: [Math.floor(Math.random() * 256), Math.floor(Math.random() * 256), Math.floor(Math.random() * 256), 0.5],
      style: 'solid',
      outline: {
        type: 'simple-line',
        color: [50, 50, 50, 255],
        width: 1,
        style: 'solid'
      }
    },
    attributes: {},
    popupTemplate: null
  }
  return forma
}

async function crearLineaPerimetro (geometry) {
  let forma = {
    aggregateGeometries: null,
    geometry: geometry,
    color: 'lightblue',
    symbol: {
      type: 'simple-line',
      color: [Math.floor(Math.random() * 256), Math.floor(Math.random() * 256), Math.floor(Math.random() * 256), 1],
      width: 3,
      style: 'solid'
    },
    attributes: {},
    popupTemplate: null
  }
  return forma
}
function hexToBytes (hex) {
  const bytes = []
  for (let c = 0; c < hex.length; c += 2) {
    bytes.push(parseInt(hex.substr(c, 2), 16))
  }
  return bytes
}
async function fetchJSON (url) {
  return await fetch(url).then((response) => {
    return response.json()
  })
}
export async function dragAndDrop (selectedFile, type, fileNumber) {
  let layer = {}

  if (type === 'geojson') {
    const urlCreada = URL.createObjectURL(selectedFile)
    layer = iniciarLayer('geojson')
    layer.url = urlCreada

    const archivo = await fetchJSON(urlCreada)
    if (archivo.metadata) {
      layer.id = archivo.metadata.title.split(' ').join('-')
      layer.title = archivo.metadata.title
    } else {
      layer.id = `layer-geojson ${fileNumber}`
      layer.title = `${'Layer GeoJSON '}${fileNumber}`
    }
  } else {
    switch (type) {
      case 'kml':
        layer = iniciarLayer('kml')
        break
      case 'zip':
        layer = iniciarLayer('shp')
        break
      default:
        Vue.notify({
          title: 'Error Drag and Drop',
          text: 'Los archivos deben ser .geojson, .kml o .zip(para mostrar archivos .shp)',
          type: 'error'
        })

        return null
    }
  }

  return layer
}
function iniciarLayer (formato) {
  const layer = {
    id: '',
    type: '',
    title: '',
    url: '',
    visible: true,
    opacity: 1,
    posicion: 999,
    addListLayer: true
  }

  switch (formato) {
    case 'geojson':
      layer.type = 'geojson'
      break
    case 'kml':
      layer.id = 'layerKML'
      layer.type = 'graphicsLayer'
      layer.title = 'Layer KML'
      break
    case 'shp':
      layer.id = 'layerSHP'
      layer.type = 'graphicsLayer'
      layer.title = 'Layer SHP'
  }

  return layer
}
export async function insertLayer (archivo, formato, retorno) {
  if (!archivo) {
    Vue.notify({
      title: 'Error Drag and Drop',
      text: 'No se ha proporcionado ningún archivo.',
      type: 'error'
    })

    return null
  }

  let geojson

  switch (formato) {
    case 'SHP':
      geojson = await procesarArchivoSHP(archivo)
      break
    case 'KML':
      geojson = await procesarArchivoKML(archivo)
      break
  }

  if (!geojson) {
    Vue.notify({
      title: 'Error Drag and Drop',
      text: 'Formato no soportado.',
      type: 'error'
    })

    return null
  }

  const graficos = await perimeterGeoJsonToGraphicsPerimeter(geojson, false)

  if (!retorno) {
    if (formato === 'KML') {
      const capa = map.findLayerById('layerKML')
      capa.removeAll()
      capa.addMany(graficos)
    } else if (formato === 'SHP') {
      const capa = map.findLayerById('layerSHP')
      capa.removeAll()
      capa.addMany(graficos)
    }
  } else {
    return graficos
  }

  return graficos
}

export async function fileToGeoJSON (archivo, formato) {
  try {
    if (!archivo) throw new Error('No se ha proporcionado ningún archivo.')

    let geojson
    if (formato === 'SHP') {
      geojson = await procesarArchivoSHP(archivo)
    } else if (formato === 'KML') {
      geojson = await procesarArchivoKML(archivo)
    } else {
      throw new Error(`Formato no soportado: ${formato}`)
    }
    const graficos = await perimeterGeoJsonToGraphicsPerimeter(geojson, true)
    const capa = map.findLayerById('layer-perimetros')
    capa.removeAll()
    capa.addMany(graficos)

    return graficos
  } catch (error) {
    console.error('Error en procesarArchivoSHP', error)
    throw error
  }
}
async function procesarArchivoSHP (archivo) {
  const zip = await JSZip.loadAsync(archivo)
  const archivos = zip.files

  const nombreShp = Object.keys(archivos).find(n => n.endsWith('.shp'))
  const nombreDbf = Object.keys(archivos).find(n => n.endsWith('.dbf'))
  const nombrePrj = Object.keys(archivos).find(n => n.endsWith('.prj'))
  const nombreShx = Object.keys(archivos).find(n => n.endsWith('.shx'))
  const nombreQml = Object.keys(archivos).find(n => n.endsWith('.qml'))

  if (!nombreShp || !nombreDbf || !nombrePrj || !nombreShx) {
    Vue.notify({
      title: 'Error Drag and Drop',
      text: 'Faltan archivos necesarios en el ZIP (.shp, .dbf, .prj, .shx).',
      type: 'error'
    })

    return null
  }
  if (tienecarpeta(archivos, nombreQml !== undefined)) {
    Vue.notify({
      title: 'Error Drag and Drop',
      text: 'El archivo ZIP no debe contener carpetas, solo los archivos necesarios (.shp, .dbf, .prj, .shx, .qml (opcional))',
      type: 'error'
    })

    return null
  }

  const [shp, dbf, prj, shx] = await Promise.all([
    zip.file(nombreShp).async('arraybuffer'),
    zip.file(nombreDbf).async('arraybuffer'),
    zip.file(nombrePrj).async('string'),
    zip.file(nombreShx).async('arraybuffer')
  ])

  if (nombreQml) {
    const qml = await zip.file(nombreQml).async('string')

    const archivoQML = new DOMParser().parseFromString(qml, 'text/xml')
  }

  const formData = new FormData()
  formData.append('shp', new Blob([shp]))
  formData.append('dbf', new Blob([dbf]))
  formData.append('prj', new Blob([prj]))
  formData.append('shx', new Blob([shx]))

  const respuesta = await api.incendio.addImportedPerimetro(formData)
  return respuesta.data
}
function tienecarpeta (archivo, tieneQML) {
  let index = null

  const archivos = [
    Object.keys(archivo).find(n => n.endsWith('.shp')),
    Object.keys(archivo).find(n => n.endsWith('.dbf')),
    Object.keys(archivo).find(n => n.endsWith('.prj')),
    Object.keys(archivo).find(n => n.endsWith('.shx'))
  ]

  if (tieneQML) {
    archivos.push(Object.keys(archivo).find(n => n.endsWith('.qml')))
  }

  for (let i = 0; i < archivos.length; i++) {
    index = archivos[i].indexOf('/')
    if (index !== -1) {
      return true
    }
  }

  return false
}
async function procesarArchivoKML (archivo) {
  const textoKML = await archivo.text()
  const domKML = new DOMParser().parseFromString(textoKML, 'application/xml')
  const geojson = toGeoJSON.kml(domKML)

  geojson.crs = {
    type: 'name',
    properties: {
      name: 'urn:ogc:def:crs:OGC:1.3:CRS84'
    }
  }

  return reproyectarGeoJSON(geojson)
}
function reproyectarGeoJSON (geojson) {
  const origen = 'EPSG:4326'
  const destino = 'EPSG:3857'
  let status = true

  geojson.features = geojson.features.map((feature) => {
    if (!feature.geometry) {
      Vue.notify({
        title: 'Error Drag and Drop',
        text: 'Error al procesar el archivo kml',
        type: 'error'
      })

      status = false
      return null
    }
    const tipo = feature.geometry.type
    const coords = feature.geometry.coordinates

    if (tipo === 'Polygon') {
      feature.geometry.coordinates = coords.map(anillo =>
        anillo.map(([lon, lat]) => proj4(origen, destino, [lon, lat]))
      )
    } else if (tipo === 'MultiPolygon') {
      feature.geometry.coordinates = coords.map(poligono =>
        poligono.map(anillo =>
          anillo.map(([lon, lat]) => proj4(origen, destino, [lon, lat]))
        )
      )
    }

    return feature
  })

  if (!status) {
    return null
  }

  return geojson
}

// #endregion

// #endregion *******************************************************************************************************************************************************************

// #region SIMULACION
let simulacionSVM = null
// let simulacionGraphics = []
// let simulationGraphics.isocronas = []
// let longitudLlamaGraphics = []
// let intensidadLlamaGraphics = []
// let velocidadPropagacionGraphics = []

let simulationGraphics = new Map()

export function getSimulacionById (id) {
  return simulationGraphics.get(id)
}

export const setSimulacionActivaId = (id) => {
  simulacionActivaId = id
}

export const getAllSimulaciones = () => {
  if (simulationGraphics.size >= 0) {
    return Array.from(simulationGraphics.values())
  } else {
    return []
  }
}

export function eliminaSimulacion (item) {
  const id = item.ID_SIMULACION

  if (simulationGraphics.size === 1) {
    clearSimulacion()
    VueInst.$store.dispatch('simulacion/cerrarSimulacionSlider', true)
  } else {
    simulationGraphics.delete(id)
    VueInst.$eventHub.$emit('update-simulaciones-list')
    const simulaciones = getAllSimulaciones()

    const activa = simulaciones[0].sim.simulacion.ID_SIMULACION
    setSimulacionActivaId(activa)
    VueInst.$eventHub.$emit('setSimulacionActiva', activa)

    if (item.TIPO === 'VIENTO') {
      const layerLineas = map.findLayerById(`layer-viento-lineas-${id}`)
      const layerPoints = map.findLayerById(`layer-viento-${id}`)

      if (layerLineas) {
        map.remove(layerLineas)
      }
      if (layerPoints) {
        map.remove(layerPoints)
      }
    } else {
      const layer = map.findLayerById('layer-simulacion')
      const layerIsocronas = map.findLayerById('layer-isocronas')
      if (layer) layer.removeAll()
      if (layerIsocronas) layerIsocronas.removeAll()

      if (item.VIENTOS) {
        const layerLineas = map.findLayerById(`layer-viento-lineas-${id}`)
        const layerPoints = map.findLayerById(`layer-viento-${id}`)

        if (layerLineas) {
          map.remove(layerLineas)
        }
        if (layerPoints) {
          map.remove(layerPoints)
        }
      }

      const graficos = simulaciones
        .filter(sim => sim.sim.simulacion.TIPO !== 'VIENTO')
        .flatMap(sim => paintSimulacionGraphicsArray(sim))

      layer.addMany(graficos)
    }
  }
}

function paintSimulacionGraphicsArray (simulacion) {
  const simData = simulationGraphics.get(simulacion.sim.id)
  if (!simData) return []

  if (simulacion.id === 'simulacion') {
    const graphicsSimulacion = simData.sim.coordenadas[0] ? [simData.sim.coordenadas[0]] : []

    const graphicsIsocronas = (simData.sim.isocronas || [])
      .filter(x => x.attributes.Elapsed_Mi <= simulacion.sim.INTERVALO)

    const graphicsGraficosSimulacion = simData.sim.graficosSimulacion
      ? simData.sim.graficosSimulacion
      : []

    return [...graphicsSimulacion, ...graphicsIsocronas, ...graphicsGraficosSimulacion]
  } else {
    const graphics = simData.sim[simulacion.id]
    return Array.isArray(graphics) ? graphics : []
  }
}

export const initSimulacionSketchViewModel = async (data) => {
  // TODO:
  try {
    const [SketchViewModel, projection] = await loadModules([
      'esri/widgets/Sketch/SketchViewModel',
      'esri/geometry/projection'
    ])
    const event = data.event
    const callback = data.callback

    let color

    switch (data.categoria) {
      case 'foco':
        color = [255, 0, 0, 0.5]
        break
      case 'combustible':
        color = [183, 244, 216, 0.5]
        break
      case 'zonaNoCombustible':
        color = [15, 10, 222, 0.5]
        break
    }

    const layer = map.findLayerById('layer-sketch-simulacion')

    simulacionSVM = new SketchViewModel({
      view: mapView,
      layer,
      pointSymbol: {

        type: 'simple-marker',
        color,
        size: 6

      },
      polylineSymbol: {
        type: 'simple-line',
        style: 'solid',
        color,
        width: 2

      },
      polygonSymbol: {
        type: 'simple-fill',
        style: 'solid',
        color

      }
    })
    simulacionSVM.on(['create', 'delete', 'update'], async (evt) => {
      let symbol, coordinates
      let geometry = null
      if (evt.state === 'complete' && evt.type === 'create') {
        await projection.load()
        geometry = projection.project(evt.graphic.geometry, {
          wkid: 25828
        })

        if (
          evt.graphic.geometry.type === 'point' &&
          evt.graphic.symbol.type === 'simple-marker'
        ) {
          symbol = simulacionSVM.pointSymbol
          coordinates = [geometry.x, geometry.y]
        } else if (evt.graphic.geometry.type === 'polyline') {
          symbol = simulacionSVM.polylineSymbol
          coordinates = geometry.paths[0]
        } else if (evt.graphic.geometry.type === 'polygon') {
          symbol = simulacionSVM.polygonSymbol
          coordinates = geometry.rings[0]
        }

        const graphic = {
          coordinates,
          type: evt.graphic.geometry.type,
          symbol
        }
        callback(graphic)
      }
    })

    // Create graphic
    simulacionSVM.create(event)
  } catch (err) {
    VueInst.$log.error(err)
  }
}

export const addPointElement = async (data) => {
  const layer = map.findLayerById('layer-sketch-simulacion')

  const callback = data.callback

  const geometry = {
    type: 'point',
    latitude: data.latitude,
    longitude: data.longitude
  }

  let color

  switch (data.categoria) {
    case 'foco':
      color = [255, 0, 0, 0.5]
      break
    case 'combustible':
      color = [183, 244, 216, 0.5]
      break
    case 'zonaNoCombustible':
      color = [15, 10, 222, 0.5]
      break
  }

  const punto = {
    geometry,
    // attributes: null, // attributes,
    symbol: {
      type: 'simple-marker',
      color,
      size: 6,
      outline: {
        type: 'simple-line',
        color: [50, 50, 50, 255],
        width: 1,
        style: 'solid'
      }
    }
  }

  layer.add(punto)
  callback(punto)
}

export const drawSimulationElements = async (elements) => {
  elements = JSON.parse(JSON.stringify(elements))

  const layer = map.findLayerById('layer-sketch-simulacion')
  // layer.graphics.removeAll()

  for (let i = 0; i < elements.length; i++) {
    let forma

    if (elements[i].geometry.symbol.type === 'esriSMS' || elements[i].geometry.symbol.type === 'simple-marker') {
      forma = await crearPunto(elements[i].latitud, elements[i].longitud, elements[i].categoria)
    }

    if (elements[i].geometry.symbol.type === 'esriSLS') {
      forma = await crearLinea(elements[i].geometry.coordinates, elements[i].categoria)
    }

    if (elements[i].geometry.symbol.type === 'esriSFS') {
      forma = await crearPoligono(elements[i].geometry.coordinates, elements[i].categoria)
    }
    layer.add(forma)
  }
}

async function crearPunto (lat, lon, categoria) {
  const geometry = {
    type: 'point',
    latitude: lat,
    longitude: lon
  }

  let color

  switch (categoria) {
    case 'foco':
      color = [255, 0, 0, 0.5]
      break
    case 'combustible':
      color = [183, 244, 216, 0.5]
      break
    case 'zonaNoCombustible':
      color = [15, 10, 222, 0.5]
      break
  }

  const forma = {
    geometry,
    symbol: {
      type: 'simple-marker',
      color,
      size: 6,
      outline: {
        type: 'simple-line',
        color: [50, 50, 50, 255],
        width: 1,
        style: 'solid'
      }
    }
  }
  return forma
}

async function crearLinea (paths, categoria) {
  const [Polyline] = await loadModules(['esri/geometry/Polyline'])
  const geometry = new Polyline({
    paths,
    spatialReference: {
      wkid: 25828
    }
  })

  let color

  switch (categoria) {
    case 'foco':
      color = [255, 0, 0, 0.5]
      break
    case 'combustible':
      color = [183, 244, 216, 0.5]
      break
    case 'zonaNoCombustible':
      color = [15, 10, 222, 0.5]
      break
  }

  const forma = {
    aggregateGeometries: null,
    geometry,
    symbol: {
      type: 'simple-line',
      color,
      width: 2,
      style: 'solid'
    },
    attributes: {},
    popupTemplate: null
  }

  return forma
}

async function crearPoligono (rings, categoria) {
  const [Polygon] = await loadModules(['esri/geometry/Polygon'])
  const geometry = new Polygon({
    rings,
    spatialReference: {
      wkid: 25828
    }
  })

  let color

  switch (categoria) {
    case 'foco':
      color = [255, 42, 4, 0.5]
      break
    case 'combustible':
      color = [183, 244, 216, 0.5]
      break
    case 'zonaNoCombustible':
      color = [15, 10, 222, 0.5]
      break
  }

  const forma = {
    aggregateGeometries: null,
    geometry,
    symbol: {
      type: 'simple-fill',
      color,
      style: 'solid',
      outline: {
        type: 'simple-line',
        color: [50, 50, 50, 255],
        width: 1,
        style: 'solid'
      }
    },
    attributes: {},
    popupTemplate: null
  }

  return forma
}

export async function obtenerCentro (geometriaData, tipo, wkidEntrada) {
  const [Polygon, Polyline, Extent] = await loadModules([
    'esri/geometry/Polygon',
    'esri/geometry/Polyline',
    'esri/geometry/Extent'
  ])

  const esriModules = { Polygon, Polyline, Extent }

  if (tipo === 'INCENDIO') {
    const puntoCentro = calcularCentroIncendio(geometriaData, wkidEntrada, esriModules)
    return proyectarPuntoAMercator(puntoCentro, wkidEntrada)
  }

  return calcularCentroVientos(geometriaData.response?.features, esriModules)
}

function calcularCentroIncendio (geometriaData, wkid, { Polygon, Polyline }) {
  const { type } = geometriaData
  const coords = geometriaData.coordinates || geometriaData.rings
  const spatialReference = { wkid }
  let poligono, polilinea

  const procesarCoordenadas = () => {
    if (geometriaData.rings) {
      return coords.filter(punto => Array.isArray(punto) && punto.length === 2)
    }
    return [coords]
  }

  switch (type?.toLowerCase()) {
    case 'point':
      if (!coords || coords.length < 2) {
        throw new Error('Las coordenadas del Point son inválidas.')
      }
      return { x: coords[0], y: coords[1] }

    case 'polygon':
      poligono = new Polygon({ rings: procesarCoordenadas(), spatialReference })
      return poligono.centroid

    case 'polyline':
      polilinea = new Polyline({ paths: procesarCoordenadas(), spatialReference })
      return polilinea.extent.center

    default:
      throw new Error(`Tipo de geometría no soportado para calcular el centro: ${type}`)
  }
}

function proyectarPuntoAMercator (puntoCentro, wkidEntrada) {
  const pointWebMercator = {
    x: puntoCentro.x,
    y: puntoCentro.y,
    z: 0,
    spatialReference: {
      wkid: 102100,
      latestWkid: 3857
    }
  }

  if (wkidEntrada === 25828 || wkidEntrada === 32628) {
    const [x3857, y3857] = convertirCanariasToWebMercator(puntoCentro.x, puntoCentro.y)
    pointWebMercator.x = x3857
    pointWebMercator.y = y3857
  } else if (wkidEntrada === 25830) {
    proj4.defs('EPSG:25830', '+proj=utm +zone=30 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs')
    const [x3857, y3857] = proj4('EPSG:25830', 'EPSG:3857', [puntoCentro.x, puntoCentro.y])
    pointWebMercator.x = x3857
    pointWebMercator.y = y3857
  } else {
    pointWebMercator.x = puntoCentro.x
    pointWebMercator.y = puntoCentro.y
  }

  return pointWebMercator
}

function calcularCentroVientos (features = [], { Polygon, Polyline, Extent }) {
  if (!features || features.length === 0) {
    throw new Error('No se pudo calcular el centro: la colección de features está vacía o es inválida.')
  }

  const extentGlobal = features.reduce((acumulador, feature) => {
    const { geometry } = feature
    const type = geometry.type.toLowerCase()
    const coords = geometry.coordinates
    let tempExtent = null

    if (type === 'point') {
      tempExtent = new Extent({
        xmin: coords[0],
        ymin: coords[1],
        xmax: coords[0],
        ymax: coords[1],
        spatialReference: 4326
      })
    } else if (type === 'polygon') {
      tempExtent = new Polygon({ rings: coords, spatialReference: 4326 }).extent
    } else if (type === 'polyline') {
      tempExtent = new Polyline({ paths: coords, spatialReference: 4326 }).extent
    }

    if (!tempExtent) return acumulador

    return acumulador ? acumulador.union(tempExtent) : tempExtent.clone()
  }, null)

  if (!extentGlobal) {
    throw new Error('No se pudo generar un Extent válido a partir de las features.')
  }

  return extentGlobal.center
}

export const clearSimulacionSketch = () => {
  const layer = map.findLayerById('layer-sketch-simulacion')
  layer.removeAll()
}
export const stopSimulacionSketchViewModel = () => {
  if (!simulacionSVM) return
  simulacionSVM.cancel()
}

export const convertListGeometryToLatLon = listgeometry => {
  const newList = []
  for (const geometry of listgeometry) {
    const newGeom = []
    for (const point of geometry) {
      const newpoint = convertirETRS89ToLatLon(point[0], point[1])

      const temp = newpoint[0]
      newpoint[0] = newpoint[1]
      newpoint[1] = temp

      newGeom.push(newpoint)
    }
    newList.push(newGeom)
  }

  return newList
}

let cacheLongitud, cacheIntensidad, cacheVelocidad
export const paintSimulacion = async (simulacion) => {
  if (!map) return
  const uuid = simulacion.sim.simulacion.ID_SIMULACION
  const tipo = simulacion.id

  simulacion.sim.id = uuid
  try {
    let response

    switch (tipo) {
      case 'simulacion':
        if (simulationGraphics.has(uuid)) {
          simulationGraphics.get(uuid).sim.modo = 'simulacion'
          break
        }
        response = await api.simulacion.getSimulacion(uuid, 32628)

        if (response.status > 200) {
          // Hacer que salga error cuando el simStatus no sea correcto
          return
        }

        simulationGraphics.set(uuid, simulacion)
        VueInst.$eventHub.$emit('update-simulaciones-list')

        simulationGraphics.get(uuid).sim.coordenadas = await createGraphicsSimulacion(response.data)
        simulationGraphics.get(uuid).sim.isocronas = await createGraphicsIsocronas(response.data)
        simulationGraphics.get(uuid).sim.graficosSimulacion = simulacion.sim.simulacion.GRAFICOS ? await createAuxiliarGraphicsSimulacion(simulacion.sim.simulacion.GRAFICOS) : []
        simulationGraphics.get(uuid).sim.modo = 'simulacion'

        if (!simulationGraphics.get(uuid).sim.simulacion || !simulationGraphics.get(uuid).sim.isocronas) {
          //  'La simulación no se ha creado correctamente'
          return
        }

        break

      case 'longitudLlama':
        if (simulationGraphics.get(uuid).sim.longitudLlama.length === 0) {
          response = await api.simulacion.getFlameLength(uuid, 32628)
          simulationGraphics.get(uuid).sim.longitudLlama = await createGraphics(response.data)
          cacheLongitud = response.data
        } else {
          simulationGraphics.get(uuid).sim.longitudLlama = await createGraphics(cacheLongitud)
        }

        simulationGraphics.get(uuid).sim.modo = 'longitudLlama'
        break

      case 'intensidadLlama':
        if (simulationGraphics.get(uuid).sim.intensidadLlama.length === 0) {
          response = await api.simulacion.getIntensity(uuid, 32628)
          simulationGraphics.get(uuid).sim.intensidadLlama = await createGraphics(response.data)
          cacheIntensidad = response.data
        } else {
          simulationGraphics.get(uuid).sim.intensidadLlama = await createGraphics(cacheIntensidad)
        }
        simulationGraphics.get(uuid).sim.modo = 'intensidadLlama'
        break

      case 'velocidadPropagacion':
        if (simulationGraphics.get(uuid).sim.velocidadPropagacion.length === 0) {
          response = await api.simulacion.getSpreadRate(uuid, 32628)
          simulationGraphics.get(uuid).sim.velocidadPropagacion = await createGraphics(response.data)
          cacheVelocidad = response.data
        } else {
          simulationGraphics.get(uuid).sim.velocidadPropagacion = await createGraphics(cacheVelocidad)
        }
        simulationGraphics.get(uuid).sim.modo = 'velocidadPropagacion'
        break

      default:
        console.error('Tipo no reconocido:', tipo)
        break
    }

    store.dispatch('shareMap/paintSimulation', { response, simulacion })
    paintSimulacionLayer(simulacion)
    if (tipo === 'simulacion') {
      await centerSimulacion(simulacion.sim.simulacion.TIPO, uuid)
    }

    simulacionActivaId = uuid
  } catch (err) {
    console.error('Error arcgis paintSimulacion ', err)
    throw err
  }
}

function paintSimulacionLayer (simulacion) {
  const layerSimulacion = map.findLayerById('layer-simulacion')

  const layerIsocronas = map.findLayerById('layer-isocronas')
  const layerGraficosSimulacion = map.findLayerById('layer-graficos-simulacion')

  const uuid = simulacion.sim.id

  const simData = simulationGraphics.get(uuid)
  if (!simData) return

  if (simulacion.id === 'simulacion') {
    simData.sim.isocronas.sort(comparador)

    layerSimulacion.graphics.items = layerSimulacion.graphics.items.concat(simData.sim.coordenadas[0]) // Solo pinta el primer anillo

    layerIsocronas.graphics.items = layerIsocronas.graphics.items.concat(simData.sim.isocronas.filter(
      (x) => (x.attributes.Elapsed_Mi <= simulacion.sim.simulacion.INTERVALO && simData.sim.id === uuid)
    ))

    layerGraficosSimulacion.graphics.items = layerGraficosSimulacion.graphics.items.concat(simData.sim.graficosSimulacion)

    layerGraficosSimulacion.visible = true
    layerIsocronas.visible = true
  } else {
    if (simData.sim.coordenadas && simData.sim.coordenadas.length > 0) {
      layerSimulacion.graphics.removeMany(simData.sim.coordenadas)
    }

    if (simData.sim.isocronas && simData.sim.isocronas.length > 0) {
      layerIsocronas.graphics.removeMany(simData.sim.isocronas)
    }

    const graphics = simData.sim[simulacion.id]

    const graphicsFinal = graphics.map(graphic => {
      graphic.attributes = {
        ...graphic.attributes,
        simId: uuid
      }
      return graphic
    })

    if (Array.isArray(graphicsFinal) && graphicsFinal.length > 0) {
      layerSimulacion.graphics.addMany(graphicsFinal)
    }

    layerSimulacion.visible = true
  }
}

async function createAuxiliarGraphicsSimulacion (data) {
  const deferred = Q.defer()

  try {
    const graphics = []
    for (let i = 0; i < data.length; i++) {
      switch (data[i].TIPO_GEOMETRIA) {
        case 'polyline':
          graphics.push(await crearLinea(JSON.parse(data[i].GEOMETRIA), data[i].TIPO_GRAFICO))
          break
        case 'polygon':
          graphics.push(await crearPoligono(JSON.parse(data[i].GEOMETRIA), data[i].TIPO_GRAFICO))
          break
      }
    }

    deferred.resolve(graphics)
  } catch (err) {
    VueInst.$log.error(err)
  }

  return deferred.promise
}

async function createGraphicsSimulacion (response) {
  const deferred = Q.defer()

  try {
    const [Polygon, Graphic, GeometryEngine] = await loadModules([
      'esri/geometry/Polygon',
      'esri/Graphic',
      'esri/geometry/geometryEngine'
    ])

    const featuresJson = response.features

    const groups = featuresJson.reduce((acc, item) => {
      const elapsedMin = item.properties?.Elapsed_Mi
      if (!acc[elapsedMin]) acc[elapsedMin] = []
      acc[elapsedMin].push(item)
      return acc
    }, {})

    const timeSteps = Object.keys(groups)
      .map(Number)
      .sort((a, b) => a - b)

    const initColor = [255, 255, 0]
    const endColor = [255, 0, 0]
    const colorGradient = getColorGradient(
      initColor,
      endColor,
      timeSteps.length
    )

    const graphics = []
    let geometriaAcumuladaAnterior = null

    for (let i = 0; i < timeSteps.length; i++) {
      const currentTime = timeSteps[i]
      const featuresInGroup = groups[currentTime]

      const rawGeometries = []

      featuresInGroup.forEach(f => {
        if (!f.geometry) return

        let rings = []
        if (f.geometry.type === 'MultiPolygon') {
          rings = f.geometry.coordinates.flat(1)
        } else if (f.geometry.type === 'Polygon') {
          rings = f.geometry.coordinates
        }

        const polygon = new Polygon({
          hasZ: false,
          hasM: false,
          rings,
          spatialReference: { wkid: 4326 }
        })
        rawGeometries.push(polygon)
      })

      if (rawGeometries.length === 0) continue
      let unionGeometry = GeometryEngine.union(rawGeometries)
      unionGeometry = GeometryEngine.simplify(unionGeometry)

      let geometriaParaPintar = unionGeometry

      if (geometriaAcumuladaAnterior) {
        geometriaParaPintar = GeometryEngine.difference(unionGeometry, geometriaAcumuladaAnterior)
      }

      if (geometriaParaPintar) {
        const color = colorGradient[i]

        const symbol = {
          type: 'simple-fill',
          color: [color[0], color[1], color[2], 0.8],
          style: 'solid',
          outline: {
            color: 'white',
            width: 0
          }
        }

        const popupTemplate = {
          title: 'Simulación',
          content: [{
            type: 'fields',
            fieldInfos: [{
              fieldName: 'Elapsed_Mi',
              label: 'Tiempo (min)'
            }]
          }]
        }

        const graphic = new Graphic({
          geometry: geometriaParaPintar,
          attributes: {
            Elapsed_Mi: currentTime,
            ...featuresInGroup[0].properties
          },
          symbol,
          popupTemplate
        })

        graphics.push(graphic)
      }

      if (geometriaAcumuladaAnterior) {
        geometriaAcumuladaAnterior = GeometryEngine.union([geometriaAcumuladaAnterior, unionGeometry])
      } else {
        geometriaAcumuladaAnterior = unionGeometry
      }
    }

    deferred.resolve(graphics)
  } catch (err) {
    console.error('Error creando geometrías simulacion:', err)
    deferred.reject(err)
  }

  return deferred.promise
}

async function createGraphics (response) {
  const deferred = Q.defer()
  try {
    const [Polygon, Graphic] = await loadModules([
      'esri/geometry/Polygon',
      'esri/Graphic'
    ])

    const featuresJson = response.features

    const initColor = [255, 255, 0] // Amarillo
    const endColor = [255, 0, 0] // Rojo
    const colorGradient = getColorGradient(
      initColor,
      endColor,
      featuresJson.length
    )

    // Crear las geometrias juntando los poligonos del mismo ElapsedMin
    const mergedFeatures = []
    featuresJson.forEach((v) => {
      const features = v
      let geometry
      if (features.geometry.coordinates.length > 1) {
        features.geometry.coordinates.forEach((geo) => {
          const newGeometry = new Polygon({
            hasZ: false,
            hasM: false,
            rings: geo,
            spatialReference: {
              wkid: 4326
            }
          })

          mergedFeatures.push({
            geometry: newGeometry,
            properties: v.properties
          })
        })
      } else {
        geometry = new Polygon({
          hasZ: false,
          hasM: false,
          rings: features.geometry.coordinates,
          spatialReference: {
            wkid: 4326
          }
        })

        mergedFeatures.push({
          geometry,
          properties: v.properties
        })
      }
    })

    // Crear los graficos
    const graphics = []
    for (let i = 0; i < mergedFeatures.length; i++) {
      const f = mergedFeatures[i]
      const geometry = f.geometry

      const color = colorGradient[i]
      const symbol = {
        type: 'simple-fill',
        color: f.properties.fill ? f.properties.fill : [color[0], color[1], color[2], 1],
        style: 'solid',
        outline: {
          color: 'white',
          width: 0
        }
      }

      const popupTemplate = {
        title: 'Simulación',
        content: [
          {
            type: 'fields',
            fieldInfos: [
              {
                fieldName: 'UpperValue',
                label: 'Valor por encima'
              },
              {
                fieldName: 'lowerValue',
                label: 'Valor por debajo'
              }
            ]
          }
        ]
      }

      const graphic = new Graphic({
        geometry,
        attributes: f.properties, // attributes
        symbol,
        popupTemplate
      })

      graphics.push(graphic)
    }

    deferred.resolve(graphics)
  } catch (err) {
    VueInst.$log.error(err)
  }

  return deferred.promise
}

let elapsedMinText = 0
async function createGraphicsIsocronas (response) {
  const deferred = Q.defer()

  try {
    const [Point, Polygon, Graphic, GeometryEngine] = await loadModules([
      'esri/geometry/Point',
      'esri/geometry/Polygon',
      'esri/Graphic',
      'esri/geometry/geometryEngine'
    ])

    const featuresJson = response.features

    // Agrupar por ElapsedMin
    const groups = await featuresJson.reduce((groups, item) => {
      const elapsedMin = item.properties?.Elapsed_Mi
      const group = groups[elapsedMin] || []
      group.push(item)
      groups[elapsedMin] = group
      return groups
    }, {})

    Object.keys(groups).forEach(key => {
      groups[key] = groups[key].filter(item => item.geometry !== null)
    })

    const initColor = [255, 255, 0] // Amarillo
    const endColor = [255, 0, 0] // Rojo
    const colorGradient = getColorGradient(
      initColor,
      endColor,
      Object.keys(groups).length
    )

    // Crear las geometrias juntando los poligonos del mismo ElapsedMin
    const mergedFeatures = []
    const elapsedMins = []
    try {
      Object.entries(groups).forEach(([k, v]) => {
        if (!Array.isArray(v) || v.length === 0) return
        const features = v

        elapsedMins.push(features[0].properties.Elapsed_Mi)
        const type = features[0].geometry.type
        let geometry

        switch (type) {
          case 'MultiPolygon':
            for (let j = 0; j < features[0].geometry.coordinates.length; j++) {
              geometry = new Polygon({
                hasZ: false,
                hasM: false,
                rings: features.map((x) => x.geometry.coordinates[j]).flat(),
                spatialReference: {
                  wkid: 4326
                }
              })

              if (geometry && geometry.type === 'polygon' && geometry.rings.length > 1) {
                const cleanedRings = geometry.rings.filter((ring, index) => {
                  return index === 0 || (ring !== undefined && ring !== null)
                })

                if (cleanedRings.length !== geometry.rings.length) {
                  geometry.rings = cleanedRings
                }
              }

              mergedFeatures.push({
                geometry,
                properties: v[0].properties
              })
            }
            break
          case 'Polygon':
            geometry = new Polygon({
              hasZ: false,
              hasM: false,
              rings: features.map((x) => x.geometry.coordinates).flat(),
              spatialReference: {
                wkid: 4326
              }
            })
            break
        }

        mergedFeatures.push({
          geometry,
          properties: v[0].properties
        })
      })
    } catch (err) {
      console.error('[Helpers/ArcGIS.js] createGraphicsIsocronas: Error creando las geometrias: ', err)
      return null
    }

    const colorFinal = [colorGradient, elapsedMins]

    // Crear los graficos
    const graphics = []
    for (let i = 0; i < mergedFeatures.length; i++) {
      const f = mergedFeatures[i]
      let geometry = f.geometry

      if (i > 0) {
        const prevFeature = mergedFeatures[i - 1]
        const prevGeometry = prevFeature.geometry
        geometry = GeometryEngine.difference(geometry, prevGeometry)

        if (!geometry) {
          continue
        }
      }

      let color
      for (let h = 0; h < colorFinal[1].length; h++) {
        if (f.properties.Elapsed_Mi === colorFinal[1][h]) {
          color = colorFinal[0][h]
          break
        }
      }

      const symbol = {
        type: 'simple-fill',
        color: [color[0], color[1], color[2], 1],
        style: 'solid',
        // Isocronas de colores
        outline: {
          color: 'white',
          width: 1
        }
      }
      const popupTemplate = {
        title: 'Simulación',
        content: [
          {
            type: 'fields',
            fieldInfos: [
              {
                fieldName: 'Elapsed_Mi',
                label: 'Elapsed Mins'
              }
            ]
          }
        ]
      }

      const graphic = new Graphic({
        geometry,
        attributes: f.properties, // attributes
        symbol
      })

      const punto = new Point({
        x: geometry.rings[0][0][0],
        y: geometry.rings[0][0][1]
      })

      const graphicText = new Graphic({
        geometry: punto,
        attributes: f.properties, // attributes
        symbol: {
          type: 'text', // autocasts as new TextSymbol()
          color: 'black',
          haloColor: 'white',
          haloSize: '1px',
          text: '',
          xoffset: 0,
          yoffset: 0,
          font: {
            // autocasts as new Font()
            size: 8,
            family: 'Arial Unicode MS',
            weight: 'bold'
          }
        },
        popupTemplate
      })

      if (f.properties.Elapsed_Mi !== elapsedMinText) {
        elapsedMinText = f.properties.Elapsed_Mi
        graphicText.symbol.text = f.properties.Elapsed_Mi
      }

      graphics.push(graphicText)
      graphics.push(graphic)
    }

    deferred.resolve(graphics)
  } catch (err) {
    VueInst.$log.error(err)
  }

  return deferred.promise
}

export const updateSimulacionTime = async (elapsedMin) => {
  if (!map) return

  // Incendios
  const layerSimulacion = map.findLayerById('layer-simulacion')
  const layerIsocronas = map.findLayerById('layer-isocronas')
  const allSimulaciones = []
  const allIsocronas = []
  const simsActualizadasIds = []

  for (const simulacion of [...simulationGraphics.values()]) {
    const simType = simulacion.sim.simulacion.TIPO
    const simId = simulacion.sim.id

    if (simType === 'INCENDIO') {
      if (simulacion.sim.modo !== 'simulacion') continue
      simsActualizadasIds.push(simId)

      const coordenadas = simulacion.sim.coordenadas
        .filter(x => x.attributes.Elapsed_Mi <= elapsedMin)
        .map(graphic => {
          graphic.attributes = {
            ...graphic.attributes,
            simId
          }
          return graphic
        })
      allSimulaciones.push(...coordenadas)

      const isocronas = simulacion.sim.isocronas
        .filter(x => x.attributes.Elapsed_Mi <= elapsedMin)
        .map(graphic => {
          graphic.attributes = {
            ...graphic.attributes,
            simId
          }
          return graphic
        })

      allIsocronas.push(...isocronas)

      if (simulacion.sim.simulacion.VIENTOS) await updateWindLayer(simulacion, elapsedMin)
    } else if (simType === 'VIENTO') {
      await updateWindLayer(simulacion, elapsedMin)
    }
  }

  if (layerSimulacion) {
    const graphicsToRemove = layerSimulacion.graphics.filter(g =>
      g.attributes && simsActualizadasIds.includes(g.attributes.simId)
    )
    layerSimulacion.removeMany(graphicsToRemove)
    layerSimulacion.addMany(allSimulaciones)
    layerSimulacion.visible = true
  }

  // Isocronas
  if (layerIsocronas) {
    const isocronasToRemove = layerIsocronas.graphics.filter(g =>
      g.attributes && simsActualizadasIds.includes(g.attributes.simId)
    )
    layerIsocronas.removeMany(isocronasToRemove)
    layerIsocronas.addMany(allIsocronas)
  }

  // Calcular superficie
  loadModules(['esri/geometry/geometryEngine']).then(([geometryEngine]) => {
    const simulation = simulationGraphics.get(simulacionActivaId)
    if (!simulation || !simulation.sim.isocronas) return

    const isocronasFiltradas = simulation.sim.isocronas.filter(x => x.attributes.Elapsed_Mi <= elapsedMin)
    let superficie = 0
    let elapsedMinPrev = 0
    const unionGeometrias = []

    for (const iso of isocronasFiltradas) {
      const min = iso.attributes.Elapsed_Mi
      if (min !== elapsedMinPrev && iso.geometry && iso.geometry.spatialReference) {
        unionGeometrias.push(iso.geometry)
        elapsedMinPrev = min
      }
    }

    const geoms = unionGeometrias.filter(g => g && g.spatialReference)
    if (geoms.length === 0) return

    const geometriaUnida = geoms.length === 1 ? geoms[0] : geometryEngine.union(geoms)
    const area = Math.abs(geometryEngine.geodesicArea(geometriaUnida, 'square-meters'))
    superficie = area / 10000 // hectáreas
    VueInst.$eventHub.$emit('superficieSimulacion', Math.round(superficie * 100) / 100)
  })
}

export const centerSimulacion = async (tipo, activeId) => {
  if (map) {
    let target
    let targetCoords
    let targetZoom

    try {
      const simulation = simulationGraphics.get(activeId)
      if (!simulation) return

      if (tipo === 'INCENDIO' && simulation.sim.coordenadas) {
        target = simulation.sim.coordenadas
        targetCoords = target
      } else {
        const centro = await obtenerCentro(simulation, 'VIENTOS', 4326)
        targetCoords = [centro.x, centro.y]
        targetZoom = 14
        target = { target: targetCoords, zoom: targetZoom }
      }

      if (isAlreadyCentered(targetCoords, targetZoom)) {
        return
      }

      await mapView.goTo(target, {
        duration: 2500,
        easing: 'out-expo'
      })
    } catch (error) {
      console.error('[Helpers/ArcGIS.js] centerSimulacion: Error al centrar la simulacion: ', error)
    }
  }
}

const isAlreadyCentered = (targetPos, targetZoom) => {
  const { center, zoom } = mapView

  const xLatLon = targetPos.length > 2 ? targetPos[0].geometry.centroid.x : targetPos.x
  const yLatLon = targetPos.length > 2 ? targetPos[0].geometry.centroid.y : targetPos.y

  const [targetX, targetY] = convertir4326to3857(xLatLon, yLatLon)

  const tolerance = 300 // Revisar valor

  const sameCoords = Math.abs(center.x - targetX) < tolerance && Math.abs(center.y - targetY) < tolerance
  const sameZoom = targetZoom ? Math.round(zoom) === Math.round(targetZoom) : true

  return sameCoords && sameZoom
}

export const clearSimulacion = () => {
  if (!map) {
    return
  }
  try {
    const mainLayers = [
      'layer-simulacion',
      'layer-isocronas',
      'layer-graficos-simulacion'
    ]

    mainLayers.forEach((id) => {
      const layer = map.findLayerById(id)
      if (layer && layer.graphics) {
        layer.removeAll()
      }
    })

    const vientoLayers = map.layers.filter((l) => l.id.startsWith('layer-viento-') || l.id.startsWith('layer-viento-lineas-'))
    vientoLayers.forEach((l) => {
      map.remove(l)
    })
  } catch (error) {
    console.error('Error en clearSimulacion: ', error)
  } finally {
    simulationGraphics = new Map()
  }
}

export const exportSimulacionBackOld = async function (simulacion, responseType, fileType) {
  const deferred = Q.defer()
  const fecha = new Date().toLocaleDateString().replaceAll('/', '-')
  const nombreSim = simulacion.NOMBRE || 'SinNombre'

  if (!map) return

  const responseSimulacion = await api.simulacion.getSimulacion(simulacion.ID_SIMULACION, 32628)
  if (responseSimulacion.data.simStatus) {
    deferred.resolve(responseSimulacion.data.simStatus)
    return deferred.promise
  }

  const geoJsonSimulacion = {
    type: 'FeatureCollection',
    features: [...responseSimulacion.data.features].reverse()
  }

  try {
    const fileResponse = await api.simulacion.exportSimulacion(simulacion.ID_SIMULACION, responseType, fileType, geoJsonSimulacion)

    switch (responseType) {
      case 'blob': {
        handleBlobDownload(fileResponse.data, fileType, nombreSim, fecha)
        break
      }
      case 'json': {
        const downloadUrl = fileResponse.data.downloadUrl
        navigator.clipboard.writeText(downloadUrl)
        return downloadUrl
      }
      default: {
        console.error('Parámetro responseType mal configurado')
      }
    }
  } catch (error) {
    console.error('Error exportando simulación:', error)
  }
}

export const exportSimulacionBack = async function (simulacion, responseType, fileType) {
  const fecha = new Date().toLocaleDateString().replaceAll('/', '-')
  const nombreSim = simulacion.NOMBRE || 'SinNombre'

  if (!map) return

  try {
    const fechas = []
    if (simulacion.TIPO === 'VIENTO') {
      for (let i = 0; i <= simulacion.NUM_HORAS; i++) {
        const horaSim = VueInst.$date.parseDate(simulacion.FECHA_INICIO).subtract(2, DayjsUnit.Hour).add(i, DayjsUnit.Hour).format(FMT.simViento)
        const fechaLimpia = `${horaSim.split('+')[0]}Z`
        fechas.push(fechaLimpia)
      }
    }
    const response = await api.simulacion.exportSimulacion(simulacion.ID_SIMULACION, simulacion.TIPO, JSON.stringify(fechas), responseType, fileType)

    if (response.status === 204 || response.data?.simStatus === 406 || response.data?.simStatus === 404) {
      return response.data?.simStatus || response.status
    }

    switch (responseType) {
      case 'blob': {
        handleBlobDownload(response.data, response.headers, nombreSim, fecha)
        break
      }
      case 'json': {
        const downloadUrl = response.data.downloadUrl

        if (document.hasFocus()) {
          navigator.clipboard.writeText(downloadUrl)
        } else {
          console.warn('No se puede copiar URL de simulacion. La pestaña no está en foco')
        }
        return downloadUrl
      }
      default: {
        console.error('Parámetro responseType mal configurado')
      }
    }
  } catch (error) {
    if (error.response?.status === 406 || error.response?.status === 404) return error.response?.status
    console.error('Error exportando simulación:', error)
    return 500
  }
}

function handleBlobDownload (data, headers, nombreSim, fecha) {
  const contentType = headers['content-type'] || 'application/octet-stream'
  const contentDisposition = headers['content-disposition']

  let backendFileName = 'simulacion.zip'

  if (contentDisposition) {
    const match = contentDisposition.match(/filename="(.+)"/)
    if (match?.[1]) {
      backendFileName = match[1]
    }
  }

  const finalFileName = `Simulacion_${nombreSim}_${fecha}_${backendFileName}`

  const blob = new Blob([data], { type: contentType })
  const downloadUrl = window.URL.createObjectURL(blob)

  const element = document.createElement('a')
  element.href = downloadUrl
  element.download = finalFileName

  document.body.appendChild(element)
  element.click()
  document.body.removeChild(element)

  URL.revokeObjectURL(downloadUrl)
}

export const downloadBlob = (blob, fileName = 'archivo.pdf') => {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = url
  link.download = fileName
  document.body.appendChild(link)

  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}

// Funcion para exportar simulacion a pdf
export const paintSimulacionFinal = async function (simulacion) {
  const deferred = Q.defer()

  if (map) {
    const layer = map.findLayerById('layer-simulacion')
    try {
      const response = await api.simulacion.getSimulacion(simulacion.ID_SIMULACION, 32628)

      if (response.data.simStatus) {
        // Hacer que salga error cuando el simStatus no sea correcto
        deferred.resolve(response.data.simStatus)
        return deferred.promise
      }
      const graphics = await createGraphicsIsocronas(response.data)
      graphics.sort(comparador)
      simulationGraphics.simulacion = graphics

      layer.graphics.items = simulationGraphics.simulacion
      await mapView.goTo(simulationGraphics.simulacion, {
        duration: 3000,
        easing: 'in-expo'
      })
      layer.visible = true
      deferred.resolve()
    } catch (err) {
      deferred.reject(err)
    }
  } else {
    deferred.reject()
  }

  return deferred.promise
}

/**
 * @param {*} from => [r, g, b, a]
 * @param {*} to => [r, g, b, a]
 * @param {*} steps => n
 */
function getColorGradient (from, to, totalNumberOfColors) {
  if (totalNumberOfColors === 0) {
    return [[0, 0, 0]]
  }
  if (totalNumberOfColors === 1) {
    return [from]
  }
  if (totalNumberOfColors === 2) {
    return [from, to]
  }

  const diffR = to[0] - from[0]
  const diffG = to[1] - from[1]
  const diffB = to[2] - from[2]
  // let diffA = to[3] - from[3]

  const steps = totalNumberOfColors - 1

  const stepR = diffR / steps
  const stepG = diffG / steps
  const stepB = diffB / steps
  // let stepA = diffA / steps

  const gradient = []
  gradient.push(from)
  for (let i = 1; i < steps; ++i) {
    const r = Math.round(from[0] + stepR * i)
    const g = Math.round(from[1] + stepG * i)
    const b = Math.round(from[2] + stepB * i)
    // let a = Math.round(from[3] + stepA * i)

    gradient.push([r, g, b])
  }
  gradient.push(to)

  return gradient
}
// #endregion

// #region VIENTOS
export const paintViento = async (simulacion) => {
  if (!map) return
  const uuid = simulacion.sim.simulacion.ID_SIMULACION
  try {
    let aux = null
    simulacion.flechas = []

    if (simulacion.sim.simulacion.TIPO === 'VIENTO') {
      for (let i = 0; i < simulacion.sim.simulacion.NUM_HORAS; i++) {
        const horaSim = DateService
          .toDayjs(simulacion.sim.simulacion.FECHA_INICIO)
          .subtract(1, DayjsUnit.Hour)
          .add(i, DayjsUnit.Hour)
          .format(FMT.simViento)
        const fechaLimpia = `${horaSim.split('+')[0]}Z`

        simulacion.flechas[i] = await api.simulacion.getSimulacionWind(uuid, fechaLimpia)
      }

      aux = simulacion.flechas[0]

      if (!simulationGraphics.has(uuid)) {
        simulationGraphics.set(uuid, simulacion)
        VueInst.$eventHub.$emit('update-simulaciones-list')
      }
      const sim = simulationGraphics.get(uuid)
      sim.sim.coordenadas = {
        x: aux.data.features[0].geometry.coordinates[0],
        y: aux.data.features[0].geometry.coordinates[1]
      }
      sim.response = aux.data

      simulacionActivaId = uuid
    } else {
      for (let i = 0; i < simulacion.sim.simulacion.NUM_HORAS; i++) {
        const horaSim = DateService
          .toDayjs(simulacion.sim.simulacion.FECHA_INICIO)
          .subtract(1, DayjsUnit.Hour)
          .add(i, DayjsUnit.Hour)
          .format(FMT.simulationWithWind)

        simulacion.flechas[i] = await api.simulacion.getJsonWindNinja(uuid, horaSim)
      }
      simulationGraphics.set(uuid, simulacion)
      aux = simulacion.flechas[0]
    }

    store.dispatch('shareMap/paintViento', aux.data)

    aux.data.simId = uuid

    if (simulacion.sim.simulacion.TIPO === 'VIENTO') {
      simulacionActivaId = uuid
      await centerSimulacion(simulacion.sim.simulacion.TIPO, uuid)
    }
    await paintVientoLayer(aux.data)
    return simulationGraphics.get(uuid).flechas
  } catch (err) {
    console.error('Arcgis error paintViento: ', err)
    throw err
  }
}

export const paintVientoLayer = async function (response) {
  const maxSpeed = Number(response.maxSpeed)
  const minSpeed = Number(response.minSpeed)

  const defaultColors = {
    minSpeed: '#0010d9',
    medSpeed: '#0080ff',
    maxSpeed: '#00ffff'
  }

  const is3D = store.getters['map/isMap3D']

  const pointLayerId = `layer-viento-${response.simId}`
  const lineLayerId = `layer-viento-lineas-${response.simId}`

  let pointLayer = map.findLayerById(pointLayerId)
  let lineLayer = map.findLayerById(lineLayerId)

  const graphicsVientos = await featuresVientoLines(response.features, response.simId)
  const graphics = await featuresVientos(response.features, response.simId)

  const [FeatureLayer] = await loadModules(['esri/layers/FeatureLayer'])
  const fields = [
    { name: 'ObjectID', alias: 'ObjectID', type: 'oid' },
    { name: 'direction', alias: 'Direction', type: 'double' },
    { name: 'speed', alias: 'Speed', type: 'double' },
    { name: 'simId', alias: 'Simulación ID', type: 'string' }
  ]

  if (!pointLayer) {
    pointLayer = new FeatureLayer({
      id: pointLayerId,
      title: `Viento Puntos ${response.simId}`,
      source: graphics,
      objectIdField: 'ObjectID',
      fields,
      geometryType: 'point',
      spatialReference: { wkid: 3857 },
      renderer: is3D ? getWindRenderer3D(minSpeed, maxSpeed, defaultColors) : getWindRenderer2D(minSpeed, maxSpeed, defaultColors),
      elevationInfo: {
        mode: 'relative-to-ground',
        offset: 50,
        unit: 'meters'
      },
      popupTemplate: {
        title: 'Viento',
        content: `
          Dirección: {direction}°<br>
          Velocidad: {speed} km/h
        `
      }
    })
    map.add(pointLayer)
    await pointLayer.load()
    await store.dispatch('map/addLayer', { id: pointLayerId, visible: true })
  }

  if (!lineLayer) {
    lineLayer = new FeatureLayer({
      id: lineLayerId,
      title: `Viento Líneas ${response.simId}`,
      source: graphicsVientos,
      objectIdField: 'ObjectID',
      fields,
      geometryType: 'polyline',
      spatialReference: { wkid: 3857 },
      renderer: getWindLineRenderer3D(minSpeed, maxSpeed, defaultColors),
      popupTemplate: {
        title: 'Viento',
        content: `
          Dirección: {direction}°<br>
          Velocidad: {speed} km/h
        `
      }
    })
    map.add(lineLayer)
    await lineLayer.load()
    await store.dispatch('map/addLayer', { id: lineLayerId, visible: true })
  }
}

export const updateWindLayer = async (simulacion, elapsedMin) => {
  const simData = simulacion.sim
  const uuid = simData.simulacion.ID_SIMULACION
  const flechas = simulacion.flechas
  const pos = Math.floor(elapsedMin / 60) - 1

  if (elapsedMin <= simData.simulacion.NUM_HORAS * 60) {
    const aux = flechas[pos]
    const response = aux.data

    const pointLayer = map.findLayerById(`layer-viento-${uuid}`)
    const lineLayer = map.findLayerById(`layer-viento-lineas-${uuid}`)

    const layerState = store.getters['map/getLayerById'](`layer-viento-${uuid}`)
    const lineState = store.getters['map/getLayerById'](`layer-viento-lineas-${uuid}`)

    const vientosActivados = layerState.visible
    const lineasActivadas = lineState.visible

    const graphics = await featuresVientos(response.features, uuid)
    const graphicsVientos = await featuresVientoLines(response.features, uuid)

    const { features: oldFeatures } = await pointLayer.queryFeatures()
    const { features: oldFeaturesVientos } = await lineLayer.queryFeatures()

    await pointLayer.applyEdits({
      addFeatures: graphics,
      deleteFeatures: oldFeatures
    })

    await lineLayer.applyEdits({
      addFeatures: graphicsVientos,
      deleteFeatures: oldFeaturesVientos
    })

    const is3D = store.getters['map/isMap3D']
    const mode = store.getters['map/wind3DMode']

    if (!is3D) {
      pointLayer.visible = vientosActivados
      lineLayer.visible = false
    } else if (mode === 'objetos') {
      pointLayer.visible = vientosActivados
      lineLayer.visible = false
    } else {
      pointLayer.visible = false
      lineLayer.visible = lineasActivadas
    }
  }
}

async function featuresVientos (features, simId) {
  const [Graphic, Point] = await loadModules([
    'esri/Graphic',
    'esri/geometry/Point'
  ])

  const graphics = []

  features.forEach((element, i) => {
    const symbol = {
      type: 'simple-marker',
      style: 'triangle',
      outline: {
        color: 'yellow',
        width: '3px'
      }
    }
    const geometry = new Point({
      x: element.geometry.coordinates[0],
      y: element.geometry.coordinates[1]
    })

    const graphic = new Graphic({
      attributes: {
        ObjectID: i + 1,
        direction: element.properties.direction,
        speed: element.properties.speed,
        simId
      },
      geometry,
      symbol
    })

    graphics.push(graphic)
  })

  return graphics
}

async function featuresVientoLines (features, simId) {
  const [Graphic, Polyline] = await loadModules([
    'esri/Graphic',
    'esri/geometry/Polyline'
  ])

  const graphics = []

  features.forEach((element, i) => {
    const coords = element.geometry.coordinates
    const direction = element.properties.direction

    const arrowGeometry = buildArrowPolyline(coords, direction)

    const geometry = new Polyline({
      paths: arrowGeometry.paths,
      spatialReference: { wkid: 4326 }
    })

    const graphic = new Graphic({
      attributes: {
        ObjectID: i + 1,
        direction: element.properties.direction,
        speed: element.properties.speed,
        simId
      },
      geometry
    })

    graphics.push(graphic)
  })

  return graphics
}

function buildArrowPolyline (coords, direction, length = 0.0012) {
  const [lon, lat] = coords

  const drawDirection = (direction + 180) % 360
  const rad = (90 - drawDirection) * Math.PI / 180

  const dx = Math.cos(rad) * length
  const dy = Math.sin(rad) * length

  const headLon = lon + dx
  const headLat = lat + dy

  const sideLen = length * 0.35
  const leftRad = rad + Math.PI / 6
  const rightRad = rad - Math.PI / 6

  const leftLon = headLon - Math.cos(leftRad) * sideLen
  const leftLat = headLat - Math.sin(leftRad) * sideLen

  const rightLon = headLon - Math.cos(rightRad) * sideLen
  const rightLat = headLat - Math.sin(rightRad) * sideLen

  return {
    paths: [
      [[lon, lat], [headLon, headLat]],
      [[headLon, headLat], [leftLon, leftLat]],
      [[leftLon, leftLat], [headLon, headLat]],
      [[headLon, headLat], [rightLon, rightLat]]
    ]
  }
}

export function updateRendererViento (colors = null) {
  const is3D = store.getters['map/isMap3D']
  const mode = store.getters['map/wind3DMode']

  const defaultColors = {
    minSpeed: '#0010d9',
    medSpeed: '#0080ff',
    maxSpeed: '#00ffff'
  }

  const activeColors = colors || defaultColors

  simulationGraphics.forEach((simulacion) => {
    let maxSpeed, minSpeed
    if (simulacion.flechas) {
      maxSpeed = simulacion.flechas[0].data.maxSpeed
      minSpeed = simulacion.flechas[0].data.minSpeed
    }

    const uuid = simulacion.sim.simulacion.ID_SIMULACION

    const pointLayer = map.findLayerById(`layer-viento-${uuid}`)
    const lineLayer = map.findLayerById(`layer-viento-lineas-${uuid}`)

    if (pointLayer && lineLayer) {
      if (!is3D) {
        pointLayer.visible = true
        lineLayer.visible = false
        pointLayer.renderer = getWindRenderer2D(minSpeed, maxSpeed, activeColors)
        return
      }

      if (mode === 'objetos') {
        pointLayer.visible = true
        lineLayer.visible = false
        pointLayer.renderer = getWindRenderer3D(minSpeed, maxSpeed, activeColors)
      } else {
        pointLayer.visible = false
        lineLayer.visible = true
        lineLayer.renderer = getWindLineRenderer3D(minSpeed, maxSpeed, activeColors)
      }
    }
  })
}
// #endregion VIENTOS

// #region IMAGEN SATELITE

export const drawImagenSatelite = async function (data, url) {
  if (map) {
    let layer = map.findLayerById('layer-imagen-satelite')

    let graphic = await createGraphicsImagenSatelite(data, url)

    layer.source.elements.removeAll() // Para que solo haya una imagen cada vez
    await layer.source.elements.add(graphic)

    layer.visible = true
  }
}

// Funcion para introducir valores en la capa de imagen satelite
async function createGraphicsImagenSatelite (data, url) {
  let deferred = Q.defer()

  try {
    const [ImageElement, ExtentAndRotationGeoreference, Extent] =
      await loadModules([
        'esri/layers/support/ImageElement',
        'esri/layers/support/ExtentAndRotationGeoreference',
        'esri/geometry/Extent'
      ])

    let source = null

    let aux = convertir4326to3857(data.LONGITUD, data.LATITUD)

    source = new ImageElement({
      image: url,
      // image: 'http://localhost:3000/satelite_imagen/B43D98CF-14A6-471E-9F00-6B225D435B3B/9751129_B43D98CF-14A6-471E-9F00-6B225D435B3B_14-7-2022_RGB',
      georeference: new ExtentAndRotationGeoreference({
        extent: new Extent({
          spatialReference: {
            wkid: 3857
          },
          xmin: aux[0] - 1113.1949134293125 * 1.369 * 7, // 1113.1949134293125 * 1.35
          ymin: aux[1] - 1113.1949134293125 * 1.369 * 7, // El 5 viene del offset de la imagen(0.05) * 100
          xmax: aux[0] + 1113.1949134293125 * 1.369 * 7,
          ymax: aux[1] + 1113.1949134293125 * 1.369 * 7
        })
      })
    })

    deferred.resolve(source)
  } catch (err) {
    VueInst.$log.error(err)
  }

  return deferred.promise
}

// export const drawGeoJsonImagenSatelite = async function (geoJson) {
//   if (map) {
//     let layer = map.findLayerById('layer-vector-imagen-satelite')
//     layer.destroy()

//     let graphic = await createGraphicsImagenSateliteGeoJson(geoJson)

//     layer.url = graphic

//     createGeoJsonLayer(layer).then((layer) => {
//       map.add(layer)
//       store.dispatch('map/addLayer', {
//         id: layer.id,
//         title: layer.title,
//         visible: layer.visible,
//         opacity: layer.opacity,
//         posicion: layer.posicion,
//         addListLayer: layer.addListLayer,
//         url: layer.url
//       })
//     })
//   }
// }

// Funcion para introducir valores en la capa de imagen satelite
async function createGraphicsImagenSateliteGeoJson (geoJson) {
  let deferred = Q.defer()

  try {
    let blob = new Blob([JSON.stringify(geoJson)], {
      // layerItem.url | geojson
      type: 'application/json'
    })

    // URL reference to the blob
    let url = URL.createObjectURL(blob)

    deferred.resolve(url)
  } catch (err) {
    VueInst.$log.error(err)
  }

  return deferred.promise
}

export const hideImagenSatelite = function () {
  if (map) {
    let layer = map.findLayerById('layer-imagen-satelite')
    layer.source.elements.removeAll()
    layer.visible = false
  }
}

// export const hideImagenSateliteGeoJSON = function () {
//   if (map) {
//     let layer = map.findLayerById('layer-vector-imagen-satelite')
//     // layer.url.elements.removeAll()

//     layer.destroy()

//     layer.url = []

//     createGeoJsonLayer(layer).then((layer) => {
//       map.add(layer)
//       store.dispatch('map/addLayer', {
//         id: layer.id,
//         title: layer.title,
//         visible: layer.visible,
//         opacity: layer.opacity,
//         posicion: layer.posicion,
//         addListLayer: layer.addListLayer,
//         url: layer.url
//       })
//     })
//   }
// }

// #endregion

// #region CONVERT_COORDINATES
export const convertirGMSLatLon = (gmsLat, gmsLon) => {
  let partsLat = gmsLat.split(/[^\d\w]+/)
  let partsLon = gmsLon.split(/[^\d\w]+/)
  let lat = convertirDMSToDD(
    Number(partsLat[0]),
    Number(partsLat[1]),
    Number(partsLat[2] + '.' + partsLat[3]),
    partsLat[4]
  )
  let lng = convertirDMSToDD(
    Number(partsLon[0]),
    Number(partsLon[1]),
    Number(partsLon[2] + '.' + partsLon[3]),
    partsLon[4]
  )
  return [lat, lng]
}
function convertirDMSToDD (degrees, minutes, seconds, direction) {
  let dd = degrees + minutes / 60 + seconds / (60 * 60)

  if (
    direction === 'S' ||
    direction === 's' ||
    direction === 'W' ||
    direction === 'w'
  ) {
    dd = dd * -1
  } // Don't do anything for N or E
  return dd
}
export const convertirLatLonGMS = (valor, tipo) => {
  let grados = Math.abs(parseInt(valor))
  let minutos = (Math.abs(valor) - grados) * 60
  let segundos = minutos
  minutos = Math.abs(parseInt(minutos))
  segundos = Math.round((segundos - minutos) * 60 * 1000000) / 1000000
  let signo = valor < 0 ? -1 : 1
  let direccion =
    tipo === 'LATITUDE' ? (signo > 0 ? 'N' : 'S') : signo > 0 ? 'E' : 'W'

  if (isNaN(direccion)) {
    grados = grados * signo
  }

  return {
    grados: grados,
    minutos: minutos,
    segundos: segundos,
    direccion: direccion,
    valor:
      grados +
      'º ' +
      minutos.toString().padStart(2, '0') +
      "' " +
      segundos.toFixed(2).toString().padStart(5, '0').replace('.', ',') +
      '" ' +
      (isNaN(direccion) ? ' ' + direccion : '')
  }
}

export const convertirETRS89 = (x, y) => {
  let zone = constants.HUSO_UTM
  let firstProjection = 'EPSG:3857'
  let secondProjection =
    '+proj=utm +zone=' + zone + ' +ellps=GRS80 +units=m +no_defs '
  return proj4(firstProjection, secondProjection, [
    parseFloat(x),
    parseFloat(y)
  ])
}
export const convertirLatLonToETRS89 = (lat, lon) => {
  let zone = constants.HUSO_UTM
  let firstProjection = 'EPSG:4326'
  let secondProjection =
    '+proj=utm +zone=' + zone + ' +ellps=GRS80 +units=m +no_defs '
  return proj4(firstProjection, secondProjection, [
    parseFloat(lon),
    parseFloat(lat)
  ])
}
export const convertirETRS89ToLatLon = (x, y) => {
  let zone = constants.HUSO_UTM
  let firstProjection =
    '+proj=utm +zone=' + zone + ' +ellps=GRS80 +units=m +no_defs'
  let secondProjection = 'EPSG:4326'
  return proj4(firstProjection, secondProjection, [
    parseFloat(x),
    parseFloat(y)
  ])
}

export const convertirMercXYToLatLon = (x, y) => {
  const firstProjection =
    '+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +units=m +k=1.0 +nadgrids=@null +no_defs'
  const secondProjection = 'EPSG:4326'
  return proj4(firstProjection, secondProjection, [
    parseFloat(x),
    parseFloat(y)
  ])
}

function convertir4326to3857 (lon, lat) {
  let x = (lon * 20037508.34) / 180
  let y = Math.log(Math.tan(((90 + lat) * Math.PI) / 360)) / (Math.PI / 180)
  y = (y * 20037508.34) / 180
  return [x, y]
}
export const convertir4326to3857Mercator = async (lon, lat) => {
  const [Point, webMercatorUtils] = await loadModules([
    'esri/geometry/Point',
    'esri/geometry/support/webMercatorUtils'
  ])

  const point4326 = new Point({
    longitude: lon,
    latitude: lat,
    spatialReference: { wkid: 4326 }
  })

  const point3857 = await webMercatorUtils.geographicToWebMercator(point4326)
  return [point3857.toJSON().x, point3857.toJSON().y]
}

export const transformarGeoJsonAEPSG4326 = geoJson => {
  return {
    ...geoJson,
    features: geoJson.features.map(feature => {
      if (feature.geometry.type === 'Polygon') {
        const nuevasCoordenadas = feature.geometry.coordinates.map(ring =>
          ring.map(([x, y]) => convertirMercXYToLatLon(x, y))
        )

        return {
          ...feature,
          geometry: {
            ...feature.geometry,
            coordinates: nuevasCoordenadas
          }
        }
      }

      return feature
    })
  }
}
export function convertirCanariasToWebMercator (x, y) {
  const canariasProj = '+proj=utm +zone=28 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs'
  const webMercatorProj = 'EPSG:3857'
  return proj4(canariasProj, webMercatorProj, [parseFloat(x), parseFloat(y)])
}

export const transformarAHuso30 = (arrGeometrias) => {
  if (!arrGeometrias || arrGeometrias.length === 0) return []
  const proj28 = '+proj=utm +zone=28 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs'
  const proj30 = '+proj=utm +zone=30 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs'
  return arrGeometrias.map(ring =>
    ring.map(punto => proj4(proj28, proj30, punto))
  )
}

// #endregion

// #region TOKEN
function getToken () {
  return new Promise((resolve, reject) => {
    let tokenData = constants.ArcGISToken

    const params = new FormData()
    params.append('client_id', tokenData.client_id)
    params.append('client_secret', tokenData.client_secret)
    params.append('grant_type', tokenData.grant_type)

    /* let params = {
      client_id: tokenData.client_id,
      client_secret: tokenData.client_secret,
      grant_type: tokenData.grant_type
    } */

    VueInst.$http
      .post(tokenData.urlToken, params)
      .then((response) => {
        let accessToken = response.data.access_token

        resolve(accessToken)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
async function registerToken () {
  const [IdentityManager] = await loadModules([
    'esri/identity/IdentityManager'
  ])
  let urlServices = constants.ArcGISToken.serverLayer
  if (IdentityManager.findCredential(urlServices) === undefined) {
    let accessToken = await getToken()
    let response = await IdentityManager.registerToken({
      server: constants.ArcGISToken.serverLayer,
      token: accessToken
    })
  }
}
// #region MAP MOVEMENT
export const setBaseMap = async (basemap) => {
  try {
    const [Basemap, WMTSLayer, WebTileLayer] = await loadModules([
      'esri/Basemap',
      'esri/layers/WMTSLayer',
      'esri/layers/WebTileLayer'
    ])

    setVisibilityLayer('hybrid-reference-layer', basemap.id === 'base4')

    if (basemap.id === 'base6') {
      // IDERioja
      let baseLayer = new WebTileLayer({
        urlTemplate: basemap.map
      })

      let tileBasemap = new Basemap({
        baseLayers: [baseLayer],
        id: basemap.id,
        title: basemap.label
      })

      map.basemap = tileBasemap
    } else if (basemap.id === 'base7') {
      // Mapa base OneAtlas
      let baseLayer = new WMTSLayer({
        url: basemap.map,
        copyright:
          '<a target=_top href="http://www.intelligence-airbusds.com"> Airbus DS, Inc</a>'
      })
      let tileBasemap = new Basemap({
        baseLayers: [baseLayer],
        id: basemap.id,
        title: basemap.label
      })

      map.basemap = tileBasemap
    } else {
      map.basemap = basemap.map
    }
  } catch (err) {
    VueInst.$log.error(err)
  }
}
// Metodo antiguo: lo añade a cada mapview/sceneview segun se cambia
/* export const setSearchWidget = async () => {
  try {
    const [Search, Locator, Extent] = await loadModules(['esri/widgets/Search', 'esri/tasks/Locator', 'esri/geometry/Extent'])

    // Filtrar locator por extent de zona
    let paramsComunidad = store.getters['map/paramsComunidad']
    let extent = paramsComunidad ? new Extent(paramsComunidad.EXTENT) : null
    let searchFilter = {
      geometry: extent
    }

    let searchWidget = new Search({
      sources: [{
        locator: new Locator({ url: 'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer' }),
        countryCode: 'ES',
        singleLineFieldName: 'SingleLine',
        name: 'Geocoding España',
        localSearchOptions: {
          minScale: 300000,
          distance: 50000
        },
        filter: searchFilter,
        placeholder: 'Buscar',
        maxResults: 3,
        maxSuggestions: 6,
        suggestionsEnabled: true,
        minSuggestCharacters: 0,
        enableInfoWindow: false,
        popupEnabled: false
      }],
      view: mapView,
      includeDefaultSources: false,
      id: 'search'
    })

    // Add the search widget to the top right corner of the view if not exist
    if (!mapView.ui.find('search')) {
      mapView.ui.add(searchWidget, {
        position: 'top-right'
      })
    }
  } catch (err) {
    VueInst.$log.error(err)
  }
} */

// Metodo nuevo: crea uno al principio en la toolbar del mapa
let searchWidget = null
export const setSearchWidget = async () => {
  let deferred = Q.defer()

  try {
    // Update Locator to match 4.24 API
    const [Search, Locator, Extent] = await loadModules([
      'esri/widgets/Search',
      'esri/rest/locator',
      'esri/geometry/Extent'
    ])

    // Filtrar locator por extent de zona
    let paramsComunidad = store.getters['map/paramsComunidad']
    let extent = paramsComunidad ? new Extent(paramsComunidad.EXTENT) : null
    let searchFilter = {
      geometry: extent
    }
    if (!searchWidget) {
      searchWidget = new Search({
        sources: [
          {
            // locator: new Locator({ url: 'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer' }),
            url: 'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer',
            countryCode: 'ES',
            singleLineFieldName: 'SingleLine',
            name: 'Geocoding España',
            localSearchOptions: {
              minScale: 300000,
              distance: 50000
            },
            filter: searchFilter,
            placeholder: 'Buscar topónimos',
            maxResults: 3,
            maxSuggestions: 6,
            suggestionsEnabled: true,
            minSuggestCharacters: 0,
            enableInfoWindow: false,
            popupEnabled: false
          }
        ],
        view: mapView,
        container: 'searchWidget',
        includeDefaultSources: false,
        id: 'search'
      })
    }
    deferred.resolve()
  } catch (err) {
    VueInst.$log.error(err)
    deferred.reject(err)
  }

  return deferred.promise
}

export const setZoom = (value) => {
  let newZoom = mapView.zoom + value
  mapView.goTo({
    target: mapView.center,
    zoom: newZoom
  })
}
export const setExtent = (extent) => {
  setExtentMap(extent)
}

async function setExtentMap (extent) {
  try {
    const [Extent, SpatialReference] = await loadModules([
      'esri/geometry/Extent',
      'esri/geometry/SpatialReference'
    ])

    let properties = {
      xmin: extent.xmin,
      ymin: extent.ymin,
      xmax: extent.xmax,
      ymax: extent.ymax
    }

    if (extent.wkid) {
      properties.spatialReference = new SpatialReference({ wkid: extent.wkid })
    } else {
      properties.spatialReference = extent.spatialReference
    }

    if (extent.viewpoint) {
      extent.viewpoint.targetGeometry.type = 'point'
      mapView.viewpoint = extent.viewpoint
    }

    mapView.extent = new Extent(properties)
  } catch (err) {
    VueInst.$log.error(err)
  }
}

export const setCenterMap = (data) => {
  if (mapView) {
    mapView.goTo({
      target: data.target,
      zoom: data.zoom
    })
  }
}
/*
export const centerCompass = () => {
  if (mapView.rotation !== undefined) {
    mapView.rotation = 0
  } else {
    mapView.goTo({
      heading: 0
    })
  }
}
*/
// #endregion

// #region CAPTURE MAP
export const captureMap = () => {
  let deferred = Q.defer()

  let pixelRatio = 3
  mapView
    .takeScreenshot({
      width: mapView.width * pixelRatio,
      height: mapView.height * pixelRatio,
      format: 'jpg'
    })
    .then((screenshot) => {
      deferred.resolve(screenshot.dataUrl)
    })

  return deferred.promise
}

export const captureOverviewMap = async () => {
  let pixelRatio = 3

  let screenshot = await mapViewOverview
    .takeScreenshot({
      width: mapViewOverview.width * pixelRatio,
      height: mapViewOverview.height * pixelRatio,
      // area: store.getters['map/paramsComunidad'].RINGS,
      format: 'jpg'
    })

  return screenshot.dataUrl
}

export const setCenterAndCaptureMap = async (data) => {
  let deferred = Q.defer()

  if (mapView) {
    await mapView.goTo({
      target: data.target,
      zoom: data.zoom
    })
    setTimeout(async () => {
      let image = await captureMap(mapView)
      deferred.resolve(image)
    }, 500)
  }

  return deferred.promise
}

export const getCaptureMapFeatures = async (graphics, layer) => {
  try {
    let deferred = Q.defer()
    let layerID = map.findLayerById(layer)
    let array = []

    if (layerID.visible === true && layerID.type === 'feature') {
      graphics.forEach(async (graphic) => {
        const query = layerID.createQuery()
        graphic.geometry = graphic.geometry ? graphic.geometry : JSON.parse(graphic.GEOMETRIA)
        query.spatialRelationship = 'intersects'
        query.returnGeometry = true
        query.outFields = ['*']

        try {
          const result = await layerID.queryFeatures(query)
          let coordMin = convertirETRS89(graphic.geometry.xmin, graphic.geometry.ymin)
          let coordMax = convertirETRS89(graphic.geometry.xmax, graphic.geometry.ymax)
          coordMin = convertirETRS89ToLatLon(coordMin[0], coordMin[1])
          coordMax = convertirETRS89ToLatLon(coordMax[0], coordMax[1])
          let x = [coordMin[0], coordMax[0]]
          let y = [coordMin[1], coordMax[1]]

          const filteredFeatures = result.features.filter(feature => (
            feature.geometry.x >= x[0] && feature.geometry.x <= x[1] &&
          feature.geometry.y >= y[0] && feature.geometry.y <= y[1]
          ))

          const attr = filteredFeatures.map(function (feature) { return feature.attributes })
          deferred.resolve(attr)
        } catch (err) {
          VueInst.$log.error(err)
        }
      })
    } else if (layerID.visible === true && layerID.type === 'graphics') {
      graphics.forEach(async (graphic) => {
        if (layerID.title === 'Gráficos Perímetros' && layerID.graphics.length > 0) {
          for (const layerGraphic of layerID.graphics) {
            const intersects = await intersectGraphic(layerGraphic, graphic)
            if (intersects && layerGraphic.attributes.LABEL) {
              let datos = {
                tipo: layerGraphic.attributes.LABEL.label,
                color: layerGraphic.attributes.LABEL.color,
                icon: layerGraphic.attributes.LABEL.src
              }
              array.push(datos)
            }
          }
        } else if (layerID.title === 'Gráficos Plan Operaciones' && layerID.graphics.length > 0) {
          for (const layerGraphic of layerID.graphics) {
            const intersects = await intersectGraphic(layerGraphic, graphic)
            if (intersects && layerGraphic.attributes.LABEL) {
              let datos = {
                plan: layerGraphic.geometry.type,
                tipo: layerGraphic.attributes.LABEL.label,
                icon: layerGraphic.attributes.LABEL.src
              }
              array.push(datos)
            }
          }
        } else {
          deferred.resolve([])
        }
        deferred.resolve(array)
      })
    } else {
      deferred.resolve([])
    }
    return deferred.promise
  } catch (err) {
    VueInst.$log.error(err)
  }
}

export const intersectGraphic = async (layerGraphic, graphic) => {
  const [Extent, Polygon, Polyline, Point, geometryEngine] = await loadModules([
    'esri/geometry/Extent',
    'esri/geometry/Polygon',
    'esri/geometry/Polyline',
    'esri/geometry/Point',
    'esri/geometry/geometryEngine'
  ])
  let geometry
  let extent = new Extent({
    xmin: graphic.geometry.xmin,
    ymin: graphic.geometry.ymin,
    xmax: graphic.geometry.xmax,
    ymax: graphic.geometry.ymax,
    spatialReference: { wkid: 102100 }
  })

  if (layerGraphic.geometry.type === 'polygon') {
    geometry = new Polygon({
      rings: layerGraphic.geometry.rings,
      spatialReference: { wkid: 102100 }
    })
  } else if (layerGraphic.geometry.type === 'point') {
    geometry = new Point({
      x: layerGraphic.geometry.x,
      y: layerGraphic.geometry.y,
      spatialReference: { wkid: 102100 }
    })
  } else if (layerGraphic.geometry.type === 'polyline') {
    geometry = new Polyline({
      paths: layerGraphic.geometry.paths,
      spatialReference: { wkid: 102100 }
    })
  } else {
    return false
  }

  return geometryEngine.intersects(geometry, extent)
}
// #endregion

// #region MEASUREMENT
let measurementTool
export const measure = async (type) => {
  try {
    const [Measurement] = await loadModules(['esri/widgets/Measurement'])

    if (!measurementTool) {
      // Se inicializa si no lo está ya
      measurementTool = new Measurement({ areaUnit: 'hectares' }) // areaUnit:

      mapView.ui.add(measurementTool, 'bottom-right')
      measurementTool.view = mapView
    }

    if (type === 'distance') {
      measurementTool.activeTool =
        mapView.type.toUpperCase() === '2D' ? type : 'direct-line'
    } else if (type === 'area') {
      measurementTool.activeTool = type
    }
  } catch (err) {
    VueInst.$log.error(err)
  }
}
export const clearMeasurement = (type) => {
  if (measurementTool) {
    measurementTool.clear()
    measurementTool = null
  }
}
// #endregion

// #region CONTORNO
export const drawContorno = async () => {
  let contornoGraphic = await createGraphicsContorno()

  let layerContorno = map.findLayerById('layer-contorno')
  layerContorno.graphics.items = contornoGraphic
}

async function createGraphicsContorno () {
  let deferred = Q.defer()

  try {
    const [Graphic, Polygon, Extent, GeometryEngine, geometryEngineAsync] = await loadModules([
      'esri/Graphic',
      'esri/geometry/Polygon',
      'esri/geometry/Extent',
      'esri/geometry/geometryEngine',
      'esri/geometry/geometryEngineAsync'
    ])

    let symbol = {
      type: 'simple-fill',
      color: [157, 198, 216, 1], // 0.3
      width: 1
    }

    let worldExtent = new Extent({
      xmin: -20037508.34278924, // -20037508.3427892430765884088807
      ymin: -19971868.8804086,
      xmax: 20037508.34278924, // 20037508.3427892430765884088807
      ymax: 19971868.8804086,
      spatialReference: {
        wkid: 3857
      }
    })

    let worldPolygon = Polygon.fromExtent(worldExtent)

    let comunidad = {
      type: 'polygon',
      rings: store.getters['map/paramsComunidad'].RINGS,
      spatialReference: {
        wkid: 102100
      }
    }
    // PROBLEMA DE CARGA LENTA
    let buffer = await geometryEngineAsync.buffer(comunidad, 10000)
    store.dispatch('map/setBufferComunidad', buffer) // Guardar poligono buffer

    let contorno = await geometryEngineAsync.difference(worldPolygon, comunidad)
    let contornoGraphic = new Graphic({
      geometry: contorno,
      symbol: symbol
    })

    deferred.resolve([contornoGraphic])
  } catch (err) {
    VueInst.$log.error(err)
  }

  return deferred.promise
}

export const pointInBuffer = async (lat, lon) => {
  let deferred = Q.defer()

  try {
    const [Point, GeometryEngine, projection] = await loadModules([
      'esri/geometry/Point',
      'esri/geometry/geometryEngine',
      'esri/geometry/projection'
    ])

    let point = new Point(lon, lat)
    point = projection.project(point, { wkid: 3857 })
    let buffer = store.getters['map/bufferComunidad']
    const contains = GeometryEngine.contains(buffer, point)

    deferred.resolve(contains)
  } catch (err) {
    VueInst.$log.error(err)
  }

  return deferred.promise
}
// #endregion

// #region COORDS_MAP
export const drawPointCoords = async (lat, lon) => {
  try {
    const [Graphic, Point] = await loadModules([
      'esri/Graphic',
      'esri/geometry/Point'
    ])

    mapView.graphics = []

    if (lat && lon) {
      let symbol = {
        type: 'simple-marker',
        style: 'cross',
        outline: {
          color: 'yellow',
          width: '3px'
        }
      }

      let geometry = new Point({
        x: lon,
        y: lat
      })

      let graphic = new Graphic({
        geometry: geometry,
        symbol: symbol
      })
      mapView.graphics.add(graphic)
      setTimeout(deletePointCoords, 60 * 1000)
    }
  } catch (err) {
    VueInst.$log.error(err)
  }
}
function deletePointCoords () {
  mapView.graphics = []
}
// #endregion

// #region SHARE MAP SKETCH VIEW MODEL
let shareMapSVM = null
export const initShareMapSketchViewModel = async () => {
  try {
    const [SketchViewModel] = await loadModules([
      'esri/widgets/Sketch/SketchViewModel'
    ])

    let layer = map.findLayerById('layer-drawSketcher')

    shareMapSVM = new SketchViewModel({
      view: mapView,
      layer: layer
    })

    shareMapSVM.on(['create', 'delete', 'update'], async (evt) => {
      if (evt.state === 'complete' && evt.type === 'create') {
        let graphic

        let attributes = {
          ID: VueInst.$uuid.createUUID()
        }

        let color = [255, 100, 100, 0.4] // REMINDER: si no se pone el color en este formato, al convertirse a JSON el alpha se 'rompe'

        if (evt.graphic.geometry.type === 'multipoint') {
          // eslint-disable-next-line no-unreachable-loop
          for (let i = 0; i < evt.graphic.geometry.points.length; i++) {
            graphic = {
              attributes: attributes,
              coordenadas: evt.graphic.geometry.points[i],
              type: 'point',
              symbol: {
                type: shareMapSVM.pointSymbol.type,
                color: color, // shareMapSVM.pointSymbol.color,
                angle: shareMapSVM.pointSymbol.angle,
                size: shareMapSVM.pointSymbol.size,
                style: shareMapSVM.pointSymbol.style
              }
            }
            store.dispatch('shareMap/addGraphics', graphic)
          }
        } else if (evt.graphic.geometry.type === 'point') {
          graphic = {
            attributes: attributes,
            coordenadas: [evt.graphic.geometry.x, evt.graphic.geometry.y],
            type: evt.graphic.geometry.type,
            symbol: {
              type: shareMapSVM.pointSymbol.type,
              color: color, // shareMapSVM.pointSymbol.color,
              size: shareMapSVM.pointSymbol.size,
              style: shareMapSVM.pointSymbol.style
            }
          }
        } else if (evt.graphic.geometry.type === 'polyline') {
          graphic = {
            attributes: attributes,
            coordenadas: evt.graphic.geometry.paths[0],
            type: 'polyline',
            symbol: {
              type: shareMapSVM.polylineSymbol.type,
              color: color, // shareMapSVM.polylineSymbol.color,
              width: shareMapSVM.polylineSymbol.width,
              style: shareMapSVM.polylineSymbol.style,
              join: shareMapSVM.polylineSymbol.join,
              miterLimit: shareMapSVM.polylineSymbol.miterLimit
            }
          }
        } else if (evt.graphic.geometry.type === 'polygon') {
          graphic = {
            attributes: attributes,
            coordenadas: evt.graphic.geometry.rings[0],
            type: 'polygon',
            symbol: {
              type: shareMapSVM.polygonSymbol.type,
              color: color, // shareMapSVM.polygonSymbol.color,
              style: shareMapSVM.polygonSymbol.style,
              outline: {
                color: 'white',
                width: 0
              }
            }
          }
        }

        store.dispatch('shareMap/addGraphics', graphic)
      } else if (evt.type === 'delete') {
        store.dispatch('shareMap/deleteGraphics', evt.graphics) // TODO:
      } else if (evt.state === 'complete' && evt.type === 'update') {
        let geometry = JSON.parse(JSON.stringify(evt.graphics[0].geometry))
        geometry.type = evt.graphics[0].geometry.type

        let g = {
          attributes: evt.graphics[0].attributes,
          geometry: geometry
        }
        store.dispatch('shareMap/updateGraphics', [g]) // TODO:
      }
    })
  } catch (err) {
    VueInst.$log.error(err)
  }
}

export const paintEventShareMap = (event) => {
  let layer = map.findLayerById('layer-drawSketcher')

  let typeEvent = event.function

  isDrawingArrow = false
  if (typeEvent === 'cancel') {
    shareMapSVM.cancel()
  } else if (typeEvent === 'reset') {
    layer.removeAll()
    shareMapSVM.reset()

    store.dispatch('shareMap/removeAllGraphics')
  } else {
    shareMapSVM.create(typeEvent)
  }
}

export const resetShareMapLayer = () => {
  let layer = map.findLayerById('layer-drawSketcher')
  layer.removeAll()
  if (shareMapSVM) {
    shareMapSVM.cancel()
  }
}

export const shareMapSimulacion = async function (data) {
  let deferred = Q.defer()

  if (map) {
    try {
      if (data.simulacion.id === 'simulacion') {
        simulationGraphics.simulacion = simulationGraphics.simulacion.length > 0 ? simulationGraphics.simulacion : await createGraphicsSimulacion(data.response.data)
        simulationGraphics.isocronas = simulationGraphics.isocronas.length > 0 ? simulationGraphics.isocronas : await createGraphicsIsocronas(data.response.data)

        if (data.simulacion.sim.GRAFICOS) {
          simulationGraphics.graficosSimulacion = simulationGraphics.graficosSimulacion.length > 0 ? simulationGraphics.graficosSimulacion : await createAuxiliarGraphicsSimulacion(data.simulacion.sim.GRAFICOS) // Probar que funcione
        }
      } else {
        simulationGraphics[data.simulacion.id] = simulationGraphics[data.simulacion.id].length > 0 ? simulationGraphics[data.simulacion.id] : await createGraphics(data.response.data)
      }

      paintSimulacionLayer(data.simulacion)

      deferred.resolve()
    } catch (err) {
      deferred.reject(err)
    }
  } else {
    deferred.reject()
  }

  return deferred.promise
}

function comparador (a) {
  // Texto tiene que estar siempre antes
  if (a.symbol.type === 'text') {
    return 1
  }

  // En cualquier otro caso, va despues
  return -1
}

export const drawShareMapGraphics = async (isNotEditingMode) => {
  let graphicsList = store.getters['shareMap/graphics']
  let graphics = await createGraphicsDraw(graphicsList)

  if (isNotEditingMode) {
    shareMapSVM.updateOnGraphicClick = false
  } else {
    shareMapSVM.updateOnGraphicClick = true
  }

  let graphicsSorted = sortGraphics(graphics)

  let layer = map.findLayerById('layer-drawSketcher')
  layer.removeAll()
  layer.addMany(graphicsSorted)
}

export const stopShareMapSketchViewModel = function () {
  store.dispatch('shareMap/removeAllGraphics')

  shareMapSVM.cancel()
  shareMapSVM.destroy()
}
// #endregion

// #region ALINEACIONES CAMPBELL
let planACSVM = null

export const initAlineacionesCampbellSketchViewModel = async function (data) {
  try {
    const [SketchViewModel] = await loadModules([
      'esri/widgets/Sketch/SketchViewModel'
    ])
    let callbackCreate = data.callbackCreate
    let callbackUpdate = data.callbackUpdate
    let callbackDelete = data.callbackDelete

    let layer = map.findLayerById('layer-alineaciones-campbell')

    planACSVM = new SketchViewModel({
      view: mapView,
      layer: layer,
      defaultCreateOptions: { hasZ: false }
    })
    planACSVM.on(['create', 'delete', 'update'], async (evt) => {
      if (evt.state === 'complete' && evt.type === 'create') {
        // Crear grafico

        let geometry
        let type = evt.graphic.geometry.type
        let symbol
        if (evt.graphic.symbol.type === 'text') {
          // Texto
          let defaultSymbol = planACSVM.pointSymbol

          geometry = [evt.graphic.geometry.x, evt.graphic.geometry.y]
          type = 'text'
          symbol = {
            type: 'text',
            color: defaultSymbol.arrowColor,
            text: defaultSymbol.text,
            xoffset: 0,
            yoffset: 0,
            haloColor: 'white',
            haloSize: '5px',
            font: {
              size: defaultSymbol.font.size,
              family: 'Arial Unicode MS',
              weight: 'bold'
            }
          }
        } else if (evt.graphic.geometry.type === 'polygon') {
          // Poligonos
          let defaultSymbol = planACSVM.polygonSymbol

          geometry = evt.graphic.geometry.rings[0]
          symbol = {
            type: defaultSymbol.type,
            color: defaultSymbol.color,
            style: defaultSymbol.style,
            outline: {
              color: defaultSymbol.outline.color,
              width: defaultSymbol.outline.width
            }
          }
        }

        let graphic = {
          ID_GRAFICOS_CAMPBELL: VueInst.$uuid.createUUID(),
          GEOMETRIA: geometry,
          TIPO: type,
          SIMBOLO: symbol
        }

        callbackCreate(graphic)
      } else if (evt.state === 'complete' && evt.type === 'update') {
        // Actualizar grafico
        const geom = evt.graphics[0].geometry

        let newGeometryGraphic
        if (geom.type === 'polygon') {
          newGeometryGraphic = geom.rings[0]
        } else {
          newGeometryGraphic = [geom.x, geom.y]
        }

        // geometry.type = graphic.geometry.type
        let newGraphic = {
          ID_GRAFICOS_CAMPBELL: evt.graphics[0].attributes.ID_GRAFICOS_CAMPBELL,
          GEOMETRIA: newGeometryGraphic
        }

        callbackUpdate(newGraphic)
      } else if (evt.type === 'delete') {
        // Borrar grafico
        callbackDelete(evt.graphics[0].attributes.ID_GRAFICOS_CAMPBELL)
      }
    })
  } catch (err) {
    VueInst.$log.error(err)
  }
}

export const paintEventAlineacionesCampbell = async (event) => {
  let typeEvent = event.function

  if (typeEvent === 'polygon') {
    planACSVM.polygonSymbol.color = event.color
    planACSVM.polygonSymbol.outline = {
      color: event.color,
      width: 2
    }
  } else if (typeEvent === 'text') {
    typeEvent = 'point'
    planACSVM.pointSymbol = {
      type: 'text',
      color: event.color,
      text: event.text,
      xoffset: 0,
      yoffset: 0,
      haloColor: 'white',
      haloSize: '20px',
      font: {
        size: event.size,
        family: 'Arial Unicode MS',
        weight: 'bold'
      }
    }
  }
  planACSVM.create(typeEvent)
}

export const cancelDrawingAlineaciones = () => {
  if (planACSVM) {
    planACSVM.cancel()
  }
}

export const stopAlineacionesCampbellSketchViewModel = () => {
  let layer = map.findLayerById('layer-alineaciones-campbell')
  layer.removeAll()

  store.dispatch('shareMap/stopAlineacionesCampbell')

  if (planACSVM == null) return
  planACSVM.cancel()
  planACSVM.destroy()
}

async function createGraphicsDrawAlineacionesCampbell (graphicList) {
  let deferred = Q.defer()

  try {
    const [Graphic, Point, Polygon] = await loadModules([
      'esri/Graphic',
      'esri/geometry/Point',
      'esri/geometry/Polygon'
    ])

    let graphicsDraw = graphicList
    let geometry
    let graphics = []
    for (let i = 0; i < graphicsDraw.length; i++) {
      let tipo = graphicsDraw[i].TIPO
      let coords = graphicsDraw[i].GEOMETRIA
      let simbolo = graphicsDraw[i].SIMBOLO

      if (tipo === 'text') {
        geometry = new Point({
          x: coords[0],
          y: coords[1],
          spatialReference: { wkid: 3857 },
          hasZ: true
        })
      } else if (tipo === 'polygon') {
        geometry = new Polygon({
          hasZ: false,
          hasM: true,
          rings: coords,
          spatialReference: { wkid: 3857 }
        })
      }

      let graphic = new Graphic({
        geometry: geometry,
        symbol: simbolo,
        attributes: {
          ID_GRAFICOS_CAMPBELL: graphicsDraw[i].ID_GRAFICOS_CAMPBELL || graphicsDraw[i].ATRIBUTOS.ID_GRAFICOS_CAMPBELL
        }
      })

      graphics.push(graphic)
    }

    deferred.resolve(graphics)
  } catch (err) {
    VueInst.$log.error(err)
  }

  return deferred.promise
}

export const drawGraphicsAlineacionesCampbell = async function (graphicList) {
  let deferred = Q.defer()

  let layer = map.findLayerById('layer-alineaciones-campbell')
  layer.removeAll()

  store.dispatch('shareMap/paintAlineacionesCampbell', graphicList)

  let graphics = await createGraphicsDrawAlineacionesCampbell(graphicList)
  let graphicsSorted = sortGraphics(graphics)
  layer.addMany(graphicsSorted)

  deferred.resolve()

  return deferred.promise
}
// #endregion

// #region COMPASS WIDGET
let compass = null
export const compassWidget = async () => {
  try {
    const [Compass] = await loadModules(['esri/widgets/Compass'])

    if (!compass) {
      // Se inicializa si no lo está ya
      compass = new Compass({
        viewModel: { // autocasts as new CompassViewModel()
          view: mapView
        },
        id: 'compasss',
        container: 'compassWidget'
      })

      // mapView.ui.add(compass, 'bottom-right')
    }
  } catch (err) {
    VueInst.$log.error(err)
  }
}

let legend = null
function updateWidgetView () {
  const is3D = store.getters['map/isMap3D']
  if (compass) {
    compass.viewModel = { view: mapView }
  }

  if (legend) {
    legend.viewModel = { view: mapView }
    if (!is3D) {
      mapView.ui.add(legend, 'bottom-right')
    } else {
      mapView.ui.add(legend, 'bottom-right')
    }
  }

  if (planACSVM) {
    planACSVM.view = mapView
  }

  if (searchWidget) {
    searchWidget.view = mapView
  }
}
// #endregion

// #region LEGEND WIDGET
export const legendWidget = async () => {
  try {
    const [Legend, Expand] = await loadModules(['esri/widgets/Legend', 'esri/widgets/Expand'])

    if (!legend) {
      // Se inicializa si no lo está ya
      legend = new Expand({
        id: 'legend',
        content: new Legend({
          view: mapView,
          style: 'card', // other styles include 'classic'
          hideLayersNotInCurrentView: true
        }),
        expandIconClass: 'esri-icon-description',
        view: mapView,
        expanded: false
      })

      mapView.ui.add(legend, 'bottom-right')
    }
  } catch (err) {
    VueInst.$log.error(err)
  }
}
// #endregion

// #region areasIncendio

export const measurePerimetros = async (graficos) => {
  const [geometryEngine] = await loadModules([
    'esri/geometry/geometryEngine'
  ])

  let area = 0
  let perimetro = 0

  let x = []
  let y = []

  graficos.forEach((graphic) => {
    graphic.geometry = graphic.geometry ? graphic.geometry : JSON.parse(graphic.GEOMETRIA)
    area += geometryEngine.geodesicArea(graphic.geometry, 'square-meters')

    perimetro += geometryEngine.geodesicLength(graphic.geometry, 'kilometers')
    x.push(graphic.geometry.xmin)
    x.push(graphic.geometry.xmax)
    y.push(graphic.geometry.ymin)
    y.push(graphic.geometry.ymax)
  })

  area /= 10000

  const measure = { area: Math.round(area * 100) / 100, perimetro: Math.round(perimetro * 100) / 100, x, y }

  return measure
}

// #endregion

/*
async function test () {
  try {
    const [MapView] = await loadModules(['esri/views/MapView'])
  } catch (err) {
    VueInst.$log.error(err)
  }
}
*/

/* export const insertLayer = (layer) => {
  if (map && layer) {
    map.add(layer)
  }
} */
export const convertirMercXYToETRS89UTM30N = (x, y) => {
  return convertirMercXYToLatLon(x, y)
}
